export const LangEn = {
    name:'en',
    data:{
        "sidebar":{
            "dashboard":"Home",
            "tasks":"My tasks",
            "identity_validation":"Identity checks",
            "create":"Create",
            "commercial":"Sales",
            "prospection":"Prospecting",
            "stats":"Statistics",
            "companies":"Companies",
            "planning":"Planning",
            "recruitment":"Recruitment",
            "missions":"Missions",
            "candidates":"Candidates",
            "pools":"Talent pools",
            "reviews":"Reviews",
            "qualifications":"Qualifications",
            "payroll_billing":"Payroll and billing",
            "timesheets":"Timesheets",
            "payroll":"Payroll",
            "billing":"Billing",
            "jobbiz_game":"Jobbiz Game",
            "intercom":"Intercom",
            "collapse":"Collapse",
            "expand":"Expand",
            "close_menu":"Close the menu",
            "open_menu":"Open the menu",
            "more":"More",
            "admin_members":"Members",
            "admin_settings":"Settings",
            "admin_appointments":"Client meetings",
            "admin_calls":"Calls",
            "admin_goals":"Sales reps goals",
            "admin_agency_goals":"Agency goals",
            "admin_sizes":"Client size",
            "admin_etp":"FTE",
            "admin_back":"Back to the CRM",
            "soon":"Coming soon"
        },
        "planning":{
            "previous":"Previous",
            "next":"Next",
            "today":"Today",
            "day":"Day",
            "week":"Week",
            "add":"Add",
            "loadError":"The planning could not be loaded.",
            "retry":"Retry",
            "undo":"Undo",
            "remote":"Remote work",
            "othersOne":"+{count} other",
            "othersMany":"+{count} others",
            "untitled":"(No title)",
            "shiftStart":"Start of shift · {hour}h",
            "shiftEnd":"End of shift · {hour}h",
            "travel":"{minutes} min",
            "myWeek":"My week",
            "toPlaceOne":"{count} visit to place",
            "toPlaceMany":"{count} visits to place",
            "placeVisits":"Place my visits",
            "progress_events":"Appointments held",
            "progress_tasks":"Tasks done",
            "progress_calls":"Calls answered",
            "roadEstimated":"of estimated driving",
            "backToWeek":"Back to my week",
            "toPlace":"To place",
            "toPlaceHint":"Drag a visit into your week, before the date shown. They are grouped by area to limit driving.",
            "allVisits":"All",
            "noVisitTitle":"No visit to place",
            "noVisitText":"Visits booked while prospecting will show here, to drag into your week.",
            "visitsOne":"{count} visit",
            "visitsMany":"{count} visits",
            "km":"{km} km",
            "alone":"isolated",
            "mostUrgentOne":"The most urgent, before its deadline",
            "mostUrgentMany":"The {count} most urgent, before their deadline",
            "tourProposed":"Suggested tour",
            "place":"Place",
            "slot":"{day}, {from} to {to}",
            "dueLate":"late",
            "dueTonight":"before tonight",
            "dueTomorrow":"before tomorrow",
            "dueBy":"before {day}",
            "morning":"{day} morning",
            "afternoon":"{day} afternoon",
            "placedOne":"Visit to {company} placed {day} at {time}",
            "placedTourOne":"1 visit placed {where}",
            "placedTour":"{count} visits placed {where} · {road} min of driving in all",
            "farTitle":"This is far from your tour",
            "farTextBefore":"{city} is {km} km from {from}, about {minutes} min of driving before {company} at {time}.",
            "farTextAfter":"{city} is {km} km from {from}, about {minutes} min of driving after {company} at {time}.",
            "farSuggestion":"{day} at {time}",
            "farOnTourMorning":"On the way of your tour in {sector} in the morning.",
            "farOnTourAfternoon":"On the way of your tour in {sector} in the afternoon.",
            "placeOn":"Place {day}",
            "keepOn":"Keep {day}",
            "cancel":"Cancel",
            "addTitle":"Add a title",
            "titleLabel":"Title",
            "close":"Close",
            "type_todo":"To do",
            "type_meeting":"Appointment",
            "noTime":"no time",
            "addDescription":"Add a description",
            "descriptionLabel":"Description",
            "moreOptions":"More options",
            "saving":"One moment…",
            "save":"Save",
            "meetingAdded":"Appointment added",
            "taskAdded":"Task added"
        },
        "appointment":{
            "close":"Close",
            "today":"Today",
            "tomorrow":"Tomorrow",
            "yesterday":"Yesterday",
            "tabDetail":"Detail",
            "tabActivity":"Activity",
            "tabComments":"Comments",
            "statusDone":"Held",
            "statusNoShow":"No-show",
            "record":"Record",
            "report":"Report",
            "reportPlaceholder":"What was said, the next step…",
            "reportSaved":"Report saved",
            "note":"Note",
            "history_created":"Appointment created",
            "history_done":"Marked as held",
            "history_no_show":"The client did not show up",
            "history_planned":"Appointment reopened",
            "reopen":"Reopen the appointment",
            "reopened":"Appointment reopened",
            "noShow":"No-show",
            "noShowDone":"Appointment missed",
            "held":"Held",
            "heldDone":"Appointment held",
            "markDone":"Mark as done",
            "call":"Call",
            "seeInPlanning":"See in the planning",
            "unplace":"Remove from the planning",
            "delete":"Delete the appointment",
            "unplaced":"Visit back to place",
            "deleted":"Appointment deleted"
        },
        "clientSizes":{
            "grand_compte":"Key account",
            "pme":"SME",
            "tpe":"Very small business",
            "label":"Client size",
            "none":"Not set",
            "saved":"Client size saved.",
            "fromEtp":"Worked out from its timesheets: its average FTE over the last 3 months, against the thresholds of the admin console.",
            "required":"Choose the client size."
        },
        "remuneration":{
            "coefficientsTitle":"Billing coefficients",
            "editCoefficients":"Edit the coefficients",
            "columnRate":"Gross hourly rate",
            "columnDelegation":"Delegation",
            "columnManagement":"Management",
            "rangeFromTo":"{from} to {to}",
            "rangeOver":"> {from}",
            "incomplete":"The grid is not complete.",
            "attested":"Matches the signed commercial proposal · attested on {day}",
            "attestedBy":"Matches the signed commercial proposal · attested on {day} by {name}",
            "neverAttested":"Default coefficients, never attested for this company.",
            "defaultData":"Default data",
            "majorationsTitle":"Increases",
            "overtime":"Overtime",
            "overtimeText":"over {hours} h a week",
            "night":"Night hours",
            "nightText":"from {start} h to {end} h",
            "sunday":"Sunday",
            "holiday":"Public holidays",
            "solidarity":"Solidarity day",
            "none":"None",
            "advantagesTitle":"Benefits",
            "ticket":"Meal voucher",
            "noTicket":"No meal vouchers",
            "ticketShare":"{share} % employer share",
            "bonuses":"Bonuses and allowances",
            "noBonus":"No bonus or allowance.",
            "addBonus":"Add a bonus",
            "removeBonus":"Remove {name}"
        },
        "reviews":{
            "tabUntreated":"To treat",
            "tabTreated":"Treated",
            "search":"Search a temp worker…",
            "columnWorker":"Temp worker",
            "columnMission":"Mission",
            "columnReview":"Review",
            "missionNumber":"#{number}",
            "openCompany":"See the company",
            "treat":"Treat the review",
            "loading":"Loading the reviews…",
            "loadError":"The reviews could not be loaded.",
            "retry":"Try again",
            "emptyTitle_untreated":"No review to treat",
            "emptyText_untreated":"The reviews companies leave their temp workers will arrive here.",
            "emptyTitle_treated":"No treated review",
            "emptyText_treated":"Treated reviews will show here."
        },
        "createMenu":{
            "title":"Create",
            "description":"What do you want to create?",
            "close":"Close",
            "task":"A task",
            "taskText":"An action, a call, an e-mail or an appointment.",
            "company":"A company",
            "companyText":"A prospect to reach out to or a client company.",
            "mission":"A mission",
            "missionText":"A mission to fill for a client company."
        },
        "home":{
            "mentions":{
                "title":"Mentions",
                "inTask":"In « {task} »",
                "unread":"Unread",
                "empty":"Nobody has mentioned you yet.",
                "loadError":"The mentions could not be loaded.",
                "seeAll":"See all",
                "close":"Close",
                "retry":"Try again",
                "filterAll":"All",
                "filterUnread":"Unread",
                "emptyTitle":"No mention",
                "emptyText":"When a colleague mentions you in a task, their comment shows here.",
                "emptyUnreadTitle":"All read",
                "emptyUnreadText":"You have opened every task you are mentioned in."
            },
            "tasks":{
                "title":"Today's tasks",
                "countOne":"{count} to do",
                "countOther":"{count} to do",
                "countLate":", {count} of them late",
                "add":"Add",
                "addTooltip":"New task · N key",
                "addTask":"Add a task",
                "emptyTitle":"No task in progress",
                "emptyText":"You have no task planned today.",
                "tabAll":"All",
                "tabAppointments":"Appointments",
                "tabCalls":"Calls",
                "tabOther":"Other",
                "groupLate":"Late",
                "groupFixed":"Scheduled",
                "groupNone":"Unscheduled",
                "groupDone":"Done",
                "moreLate":"See the {count} other late tasks",
                "today":"Today",
                "yesterday":"Yesterday",
                "done":"Done",
                "doneAt":"Done at {time}",
                "markDone":"Mark as done",
                "externalCheck":"Ticked in Google Calendar",
                "markUndone":"Mark as to do",
                "appointment":"Appointment",
                "callList":"Today's call list",
                "callListProgress":"Prospecting · {done} / {total} calls",
                "callBack":"Call {name} back",
                "switchboard":"the switchboard",
                "doneTask":"Task completed",
                "doneAppointment":"Appointment done",
                "doneCallback":"Callback done",
                "undo":"Undo"
            },
            "order":{
                "link":"Why this order?",
                "title":"The order of the list",
                "late":"The {count} most recent, the others are in My tasks.",
                "fixed":"Those with a time, in the order of the day.",
                "none":"Without a time, to do during the day.",
                "done":"At the end, folded.",
                "calls":"Callbacks and prospecting calls stay in « Today's call list »."
            },
            "calls":{
                "title":"Today's calls",
                "toQualifyOne":"{count} call to qualify before resuming the list.",
                "toQualifyOther":"{count} calls to qualify before resuming the list.",
                "qualify":"Qualify the call",
                "none":"No call planned today. Add prospects to start your list.",
                "prospectionMode":"Prospecting mode",
                "finished":"Well done! {reached} contacts reached and {booked} appointments booked today.",
                "recap":"See the recap",
                "leftOne":"{count} call left to make",
                "leftOther":"{count} calls left to make",
                "late":", {count} of them late",
                "next":" Next callback at {time}: {name}.",
                "someone":"a contact"
            },
            "agenda":{
                "title":"Planning",
                "open":"Open the planning",
                "add":"Add an appointment",
                "toPlace":"{count} appointments to place",
                "urgent":"{count} of them before tomorrow",
                "empty":"No appointment today.",
                "emptyFree":"No appointment today. Your planning is free."
            },
            "loadError":"The home page could not load.",
            "retry":"Retry",
            "comingSoon":"Available with the prospecting mode, coming to app.admin."
        },
        "prospection":{
            "title":"Today's call list",
            "comingSoon":"Coming to app.admin.",
            "commands":{
                "sessions":"View my sessions",
                "edit":"Edit the list",
                "finishEdit":"Done",
                "addProspect":"Add a prospect"
            },
            "banner":{
                "title":"Prospecting calls",
                "discovery":"Discovery",
                "followup":"Follow-ups",
                "ring":"{done}/{goal}"
            },
            "status":{
                "editing":"Remove calls, then pick others from the global list.",
                "finishedGoal":"Finished in {duration}, goal reached",
                "finished":"Finished in {duration}",
                "goalReached":"Today's goal reached, well done!",
                "remainingOne":"{count} more call to reach today's goal.",
                "remainingOther":"{count} more calls to reach today's goal."
            },
            "duration":{
                "minutesOne":"{count} minute",
                "minutesOther":"{count} minutes",
                "hours":"{hours} h",
                "hoursMinutes":"{hours} h {minutes}"
            },
            "blocks":{
                "plannedTitle":"Scheduled",
                "queueTitle":"Call queue",
                "queueEmpty":"The queue is empty: pick calls from the global list.",
                "done":"Done"
            },
            "results":{
                "answered":"Answered",
                "callback":"Call back",
                "no_answer":"No answer",
                "not_interested":"Not interested"
            },
            "sources":{
                "phone":"Phone",
                "field":"Field",
                "referral":"Referral",
                "search":"Organic search",
                "social":"Social media",
                "inbound":"Inbound request",
                "field_visit":"Field visit"
            },
            "row":{
                "subline":"{source} · {city}",
                "call":"Call {phone}",
                "remove":"Remove from the list",
                "removeDisabled":"Call in progress",
                "pickGlobal":"Pick from the global list"
            },
            "tags":{
                "discovery":"Discovery",
                "followup":"Follow-up",
                "discoveryAttempt":"Discovery · attempt {n}",
                "followupAttempt":"Follow-up {n}",
                "atTime":"{label} · {time}",
                "atDay":"{label} · {day} {time}"
            },
            "toasts":{
                "removed":"{company} was removed from today's list",
                "postponedTomorrow":"Callback of {company} moved to tomorrow, {time}",
                "postponedDay":"Callback of {company} moved to {day}, {time}",
                "undo":"Undo",
                "added":"{company} added to the list"
            },
            "global":{
                "title":"Global list",
                "description":"Your prospects with no call planned: add some to today's list.",
                "inDay":"In today's list: {discovery} discovery calls out of {discoveryGoal}, {followup} follow-ups out of {followupGoal}.",
                "tabs":{
                    "discovery":"Discovery",
                    "followup":"Follow-ups"
                },
                "search":"Search a company, a city, a contact",
                "subline":"{contact} · {city}",
                "motif":{
                    "inbound":"Inbound request on {date}",
                    "added":"Added on {date}",
                    "missedOne":"{count} unanswered call, the last one on {date}",
                    "missedOther":"{count} unanswered calls, the last one on {date}",
                    "lastCall":"Last call on {date}"
                },
                "add":"Add",
                "added":"Added",
                "showAll":"See all my prospects",
                "done":"Done",
                "emptySearchTitle":"No prospect found",
                "emptySearchText":"No prospect matches your search.",
                "emptyTab":{
                    "discovery":"No prospect to suggest for discovery",
                    "followup":"No prospect to suggest for follow-up"
                },
                "emptyTabText":"They are all in a call list or have already been called today."
            },
            "idle":{
                "title":"No call in progress",
                "launchOne":"Start the session: the call in the queue comes up, the contact's card shows here, then their number is dialed.",
                "launchOther":"Start the session: the {count} calls in the queue follow one another, each contact's card shows here, then their number is dialed.",
                "launch":"Start the session",
                "call":"Click « Call » next to a prospect: their card shows here during the call, to note what was said.",
                "callButton":"Call {name}"
            },
            "empty":{
                "title":"No call planned today",
                "text":"Pick prospects from the global list, or add a new one."
            },
            "finished":{
                "title":"All of today's calls are done",
                "text":"Well done! You can carry on with other prospects.",
                "reachedOne":"{count} contact reached",
                "reachedOther":"{count} contacts reached",
                "callbacksOne":"{count} callback",
                "callbacksOther":"{count} callbacks"
            },
            "states":{
                "globalList":"Global list",
                "addProspect":"Add a prospect",
                "loadError":"Could not load: {error}"
            },
            "side":{
                "finishedTitle":"Session finished",
                "readyTitle":"Ready to prospect?",
                "upcomingOne":"The callback is in your next call lists.",
                "upcomingOneMissed":"The callback is in your next call lists, including {count} unanswered call.",
                "upcomingOther":"The {count} callbacks are in your next call lists.",
                "upcomingMissedOne":"The {total} callbacks are in your next call lists, including {count} unanswered call.",
                "upcomingMissedOther":"The {total} callbacks are in your next call lists, including {count} unanswered calls.",
                "upcomingNone":"No callback planned for the coming days.",
                "readyText":"Start with one of the suggested prospects, or add a new one.",
                "suggested":"Suggested prospects",
                "never":"Never called",
                "today":"Called today",
                "sinceOne":"No contact for {count} day",
                "sinceOther":"No contact for {count} days",
                "add":"Add",
                "noSuggestTitle":"No prospect to suggest",
                "noSuggestText":"All your prospects are already in a call list.",
                "noProspectTitle":"No prospect",
                "noProspectText":"Add your first prospects."
            },
            "sheet":{
                "close":"Close",
                "pending":"The full call sheet comes with the rest of the prospecting mode."
            },
            "addProspect":{
                "title":"Add a prospect",
                "subtitle":"It joins your call list for today.",
                "close":"Close",
                "search":{
                    "label":"Company *",
                    "placeholder":"Trade name or SIRET",
                    "hint":"Trade name or SIRET (14 digits)",
                    "loading":"Searching",
                    "rateLimited":"Too many searches, please try again in a moment.",
                    "unavailable":"Directory unavailable.",
                    "empty":"No company found.",
                    "resultLine":"SIRET {siret} · {city}",
                    "alreadyIn":"already in Jobbiz",
                    "footer":"Official company directory",
                    "manual":"Enter manually"
                },
                "followed":{
                    "banner":"This company is already in Jobbiz: {name} ({city}) has been followed by {firstname} since {date}.",
                    "bannerSelf":"This company is already in your prospects: {name} ({city}), since {date}.",
                    "bannerClient":"This company is already in Jobbiz: {name} ({city}).",
                    "text":"You can open its record, or ask {firstname} to hand it over to you.",
                    "textOpen":"You can open its record.",
                    "open":"View record"
                },
                "company":{
                    "change":"Change",
                    "manualLine":"Entered manually",
                    "nameLabel":"Company *",
                    "nameRequired":"The name is required."
                },
                "address":{
                    "label":"Address",
                    "hint":"Prefilled from the SIRET, editable"
                },
                "phone":{
                    "label":"Phone *",
                    "placeholder":"0696 12 34 56"
                },
                "phoneErrors":{
                    "required":"The number is required.",
                    "international":"Incomplete or unknown international number.",
                    "leadingZero":"The number starts with 0, e.g. 0696 12 34 56",
                    "tooShort":"Incomplete number: 10 digits expected, e.g. 0696 12 34 56",
                    "tooLong":"Number too long: 10 digits expected, e.g. 0696 12 34 56"
                },
                "contacts":{
                    "title":"Contacts",
                    "optional":"optional",
                    "add":"Add a contact",
                    "addAnother":"Add another contact",
                    "card":"Contact {n}",
                    "remove":"Remove this contact",
                    "name":"First and last name",
                    "position":"Position",
                    "phone":"Direct phone",
                    "email":"Email",
                    "emailPlaceholder":"firstname.lastname@company.com",
                    "adminHint":"The administrator of the future Jobbiz account"
                },
                "sector":{
                    "label":"Sector",
                    "placeholder":"Choose the sector…",
                    "hint":"It sets the billing coefficient grid."
                },
                "sectors":{
                    "retail":"Retail / Sales",
                    "hospitality":"Hotels, cafés, restaurants",
                    "industry":"Industry",
                    "logistics":"Logistics",
                    "automotive":"Automotive",
                    "temp_transport":"Temp work - transport",
                    "other":"Other"
                },
                "source":{
                    "label":"How did you find it?"
                },
                "today":"Add to my call list for today",
                "cancel":"Cancel",
                "submit":"Add the prospect",
                "submitting":"Adding…",
                "added":"Prospect added",
                "failed":"Unable to add: {error}"
            },
            "errors":{
                "generic":"Something went wrong, please try again.",
                "INVALID_ID":"Invalid identifier.",
                "INVALID_CALLBACK":"This callback is invalid.",
                "PROSPECT_FORBIDDEN":"This prospect is not assigned to you.",
                "CALLBACK_FORBIDDEN":"This callback is not assigned to you.",
                "SESSION_FORBIDDEN":"This call session is not yours.",
                "FORBIDDEN_ROLE":"Your role does not give access to prospecting.",
                "PROSPECT_NOT_FOUND":"This prospect could not be found.",
                "CALLBACK_NOT_FOUND":"This callback could not be found.",
                "PROSPECT_NOT_ACTIVE":"This prospect is no longer active.",
                "CALLBACK_ALREADY_DONE":"This callback has already been made.",
                "INVALID_PROSPECT_FIELD":"A prospect field is invalid.",
                "INVALID_PHONE":"This phone number is invalid.",
                "INVALID_SIRET":"This SIRET is invalid.",
                "SIRET_ALREADY_FOLLOWED":"This company is already in Jobbiz.",
                "INVALID_ASSIGNEE":"This sales rep cannot follow this prospect.",
                "SESSION_NOT_FOUND":"This call session could not be found.",
                "INTERNAL_ERROR":"Server error, please try again in a moment.",
                "TOKEN_INVALID_OR_EXPIRED":"Your session has expired, please log in again."
            }
        },
        "tasks":{
            "tabTodo":"To do",
            "tabDone":"Done",
            "search":"Search",
            "filter":"Filter",
            "add":"Add",
            "addTooltip":"New task · N key",
            "columnTask":"Task",
            "columnType":"Type",
            "columnCompany":"Company",
            "columnDue":"Due",
            "columnTime":"Time",
            "columnAssignee":"Assigned to",
            "groupLate":"Late",
            "groupToday":"Today",
            "groupTomorrow":"Tomorrow",
            "groupLater":"Later",
            "groupDone":"Done",
            "openCompany":"Open the company",
            "unread":"New comment",
            "today":"Today",
            "tomorrow":"Tomorrow",
            "yesterday":"Yesterday, {day}",
            "doneOn":"Done {day}",
            "appointment":"Appointment",
            "rowTask":"Task",
            "rowAppointment":"Appointment",
            "rowCallback":"Callback",
            "markDone":"Mark as done",
            "markUndone":"Mark as to do",
            "doneTask":"Task completed",
            "reopenTask":"Task reopened",
            "doneAppointment":"Appointment done",
            "reopenAppointment":"Appointment reopened",
            "doneCallback":"Callback done",
            "reopenCallback":"Callback reopened",
            "undo":"Undo",
            "assigned":"Task assigned to {name}",
            "movedToday":"Task moved to today",
            "movedTomorrow":"Task moved to tomorrow",
            "movedLater":"Task moved to next week",
            "emptyFilteredTitle":"No task found",
            "emptyFilteredText":"No task matches your search or your filters.",
            "emptyTodoTitle":"No task to do",
            "emptyTodoText":"You have no task to do for now, those assigned to you will show here.",
            "emptyDoneTitle":"No task done",
            "emptyDoneText":"You have not completed a task yet, those you tick will show here.",
            "filterDue":"Due",
            "filterTypes":"Type",
            "filterDay":"A given day",
            "dueLate":"Late",
            "dueToday":"Today",
            "dueTomorrow":"Tomorrow",
            "dueWeek":"This week",
            "dueNext":"Next week",
            "dueLater":"Later",
            "kanbanAdd":"Add a task",
            "kanbanDrop":"Drop here",
            "loadError":"The tasks could not load.",
            "retry":"Retry",
            "comingSoon":"A callback opens in the prospecting mode, coming to app.admin.",
            "peopleTeam":"The whole team",
            "peopleMe":"{name} (me)",
            "peopleMeShort":"me",
            "titleMine":"My tasks",
            "titlePeople":"Tasks of {names}",
            "titleTeam":"Tasks of the whole team",
            "titleMe":"me",
            "kanbanDoneOn":"Done {day}",
            "errors":{
                "INVALID_ID":"Invalid identifier.",
                "INVALID_PEOPLE":"This selection of people is not valid.",
                "INVALID_TASK_FIELD":"A field of the task is not valid.",
                "INVALID_TASK_TYPE":"This task type does not exist.",
                "INVALID_DUE_ON":"The due date is not a valid date.",
                "INVALID_DUE_TIME":"The time is not valid.",
                "INVALID_DURATION":"The duration must be between 5 min and 8 h.",
                "TASK_TITLE_REQUIRED":"Add a title or a description.",
                "TASK_TARGET_REQUIRED":"A call or an email needs a company, a group or a contact.",
                "UNKNOWN_COMPANY":"This company no longer exists.",
                "UNKNOWN_GROUP":"This group no longer exists.",
                "INVALID_ASSIGNEE":"This person cannot receive tasks.",
                "TEAM_VIEW_FORBIDDEN":"Only an agency manager sees the team's tasks.",
                "TASK_FORBIDDEN":"You do not have access to this task.",
                "TASK_WRITE_FORBIDDEN":"You cannot edit this task.",
                "TASK_REASSIGN_FORBIDDEN":"Only its creator and an agency manager can reassign this task.",
                "TASK_DELETE_FORBIDDEN":"Only its creator and an agency manager can delete this task.",
                "TASK_NOT_FOUND":"This task no longer exists.",
                "COMMENT_BODY_REQUIRED":"The comment is empty.",
                "COMMENT_TOO_LONG":"The comment is longer than 5,000 characters.",
                "INVALID_MENTIONS":"One of the mentioned colleagues cannot be mentioned.",
                "FORBIDDEN_ROLE":"Your role does not give access to tasks.",
                "TASK_NOT_EMAIL":"This task is not an e-mail.",
                "TASK_ALREADY_DONE":"This task is already done.",
                "TASK_EMAIL_NO_COMPANY":"Link the task to a company to send the e-mail.",
                "TASK_EMAIL_NO_ADDRESS":"The contact has no valid e-mail address.",
                "TASK_EMAIL_NOT_READY":"Add a subject and a message before sending.",
                "EMAIL_SENDING_DISABLED":"Sending e-mails is turned off on this environment.",
                "EMAIL_SEND_FAILED":"The e-mail was not sent. Please try again in a moment.",
                "INVALID_NOTE":"Invalid note.",
                "INVALID_ORIGIN":"Invalid origin.",
                "INTERNAL_ERROR":"An error occurred. Please try again.",
                "default":"An error occurred. Please try again."
            }
        },
        "companies":{
            "tabProspects":"Prospects",
            "tabNew":"New",
            "tabOld":"Existing",
            "tabLost":"Lost",
            "search":"Search a company",
            "filter":"Filter",
            "add":"Add",
            "openGroup":"Open the group",
            "columnCompany":"Company",
            "columnDepartment":"Department",
            "columnCategory":"Category",
            "columnGroup":"Group",
            "columnAction":"Next action",
            "columnCreated":"Created on",
            "columnClientSince":"Client since",
            "columnRecruiter":"Recruitment",
            "columnCommercial":"Sales rep",
            "columnReason":"Reason",
            "columnRelaunch":"Follow-up",
            "columnLostOn":"Lost on",
            "reasonTooltip":"Summarised by AI from the exchanges",
            "loading":"Loading the companies",
            "createdOn":"Created on {day}",
            "actionCallback":"Call back {when}",
            "relaunchIn":"Follow up in {month}",
            "noRelaunch":"No follow-up",
            "assignCommercial":"Assign a sales rep",
            "assignRecruiter":"Assign a recruiter",
            "commercialAssigned":"{company} assigned to {name}",
            "recruiterAssigned":"{name} now handles the recruitment of {company}",
            "me":"{name} (me)",
            "filterDepartment":"Department",
            "filterCategory":"Category",
            "filterAction":"Next action",
            "filterCommercial":"Sales rep",
            "filterSupplier":"Supplier",
            "filterMissions":"Number of missions",
            "filterPay":"Pay conditions",
            "pickDepartment":"Select a department",
            "noDepartment":"No department",
            "allCategories":"All categories",
            "actionWith":"With a next action",
            "actionWithout":"Without a next action",
            "missionsNone":"No mission",
            "missionsAtLeast":"At least a number of missions",
            "missionsMin":"Minimum number of missions",
            "missionsAtLeastCount":"At least {count} mission(s)",
            "payIncomplete":"Incomplete conditions",
            "payIncompleteDetail":"Night hours, overtime, Sundays or public holidays to fill in",
            "emptyFilteredTitle":"No company found",
            "emptyFilteredText":"No company of this tab matches your search or your filters.",
            "emptyTitle":"No company in this tab",
            "empty_prospects":"The companies to canvass will show here.",
            "empty_new":"The companies that became clients less than 90 days ago will show here.",
            "empty_old":"The companies that have been clients for more than 90 days will show here.",
            "empty_lost":"The lost prospects and clients will show here, with the reason and the planned follow-up.",
            "loadError":"The companies could not load.",
            "retry":"Retry"
        },
        "viewToggle":{
            "list":"List view",
            "kanban":"Kanban view"
        },
        "record":{
            "someone":"Someone",
            "companyMissing":"This company no longer exists",
            "groupMissing":"This group no longer exists",
            "contactMissing":"This contact is no longer on the record",
            "backCompanies":"Companies",
            "comingSoon":"Available with the call list and the prospecting mode, coming to app.admin.",
            "stageClient":"Company turned client",
            "stageProspect":"Company back to prospect",
            "resent":"Invitation sent again to {email}",
            "planTask":"Plan a task",
            "planMeeting":"Book a meeting",
            "openTask":"Open the task",
            "postpone":"Postpone",
            "call":"Call",
            "outcome":"Log the outcome",
            "fieldLegalName":"Legal name",
            "fieldGroup":"Group",
            "fieldAddress":"Address",
            "fieldSiret":"SIRET",
            "fieldSupplier":"Staffing platform",
            "noSupplier":"No platform",
            "fieldApe":"APE code",
            "fieldLegalForm":"Legal form",
            "fieldStaff":"Staff",
            "staff":"{count} employees",
            "fieldCapital":"Share capital",
            "fieldAgreement":"Collective agreement",
            "fieldCategory":"Category",
            "fieldClientSince":"Client since",
            "fieldCreated":"Created on",
            "fieldCommercial":"Sales rep",
            "actions":"Actions",
            "editCompany":"Edit the company",
            "toClient":"Turn into a client",
            "markLost":"Mark as lost",
            "toProspect":"Back to prospect",
            "toGroup":"Make it a group",
            "deleteCompany":"Delete the company",
            "addToCalls":"Add to my call list of the day",
            "stage_prospect":"Prospect",
            "stage_client":"Client",
            "stage_lost":"Lost",
            "number":"No. {number}",
            "inGroup":"Group {name}",
            "actionNote":"Note",
            "actionEmail":"E-mail",
            "actionCall":"Call",
            "noPhone":"No phone number to call.",
            "actionTask":"Task",
            "actionMeeting":"Meeting",
            "actionMore":"More",
            "actionContact":"Contact",
            "addContact":"Add a contact",
            "nextAction":"Next action",
            "noNextAction":"Nothing planned",
            "about":"About",
            "seeMore":"See more",
            "seeLess":"See less",
            "tab_overview":"Overview",
            "tab_activity":"Activity",
            "tab_contacts":"Contacts",
            "tab_missions":"Missions",
            "tab_billing":"Billing",
            "tab_pay":"Pay conditions",
            "since":"since {day}",
            "upcoming":"Upcoming",
            "upcomingEmptyTitle":"Nothing planned",
            "upcomingEmptyText":"Upcoming meetings, tasks and callbacks will show here.",
            "recent":"Latest exchanges",
            "recentEmptyTitle":"No exchange",
            "recentEmptyText":"The latest calls, e-mails and notes will show here.",
            "kpiMissions":"Missions under way",
            "kpiToFillOne":"{count} mission to fill",
            "kpiToFillMany":"{count} missions to fill",
            "kpiAllFilled":"All filled",
            "kpiRevenue":"Revenue, last 12 months",
            "kpiGrowth":"{growth} % vs last year",
            "kpiFirstYear":"First year",
            "kpiNotClient":"Not a client yet",
            "kpiNoInvoices":"Invoices not visible with your access",
            "kpiLoading":"Adding up…",
            "kpiUnpaid":"Unpaid invoices",
            "kpiUnpaidOne":"{count} invoice pending",
            "kpiUnpaidMany":"{count} invoices pending",
            "kpiNoDelay":"Nothing late",
            "nextWhen":"{day} at {time}",
            "today":"Today",
            "nextCallback":"Call {name} back",
            "switchboard":"the switchboard",
            "nextMeeting":"Meeting with {name}",
            "nextMeetingAlone":"Meeting",
            "results":"Results",
            "resultsHeldOne":"Meeting held",
            "resultsHeldMany":"Meetings held",
            "resultsRequestsOne":"Inbound request",
            "resultsRequestsMany":"Inbound requests",
            "resultsSalesOne":"Sale signed",
            "resultsSalesMany":"Sales signed",
            "resultsRevenue":"Revenue generated",
            "resultsShowUp":"Show-up",
            "resultsClosing":"Closing",
            "ambassador":"Ambassador",
            "pending":"Invitation pending",
            "access":"{role} access",
            "contactsCount":"Contacts ({count})",
            "contactsEmptyTitle":"No contact",
            "contactsEmptyText":"Add the people you talk to in this company: their position, their phone, their e-mail.",
            "registered":"On Jobbiz · {count}",
            "notRegistered":"Not on Jobbiz · {count}",
            "resend":"Send the invitation again",
            "invite":"Invite",
            "groupContacts":"Group contacts ({count})",
            "groupContactsEmpty":"The group's HR, purchasing or management are added on its record.",
            "missionsTab":"Missions",
            "workersTab":"Temp workers",
            "createMission":"Create a mission",
            "pickCompanyTitle":"For which company?",
            "pickCompanySearch":"Search a company",
            "pickCompanyEmpty":"No company matches.",
            "missionsEmptyTitle":"No mission",
            "missionsEmptyText":"The missions the company creates on Jobbiz will show here, under way, upcoming then over.",
            "missions_current":"Under way",
            "missions_upcoming":"Upcoming",
            "missions_done":"Over",
            "noWorker":"No temp worker assigned",
            "workersEmptyTitle":"No temp worker",
            "workersEmptyText":"The temp workers who worked for this company will show here, with the review it left them.",
            "workerMissionsOne":"{count} mission done",
            "workerMissionsMany":"{count} missions done",
            "notRated":"Not rated yet",
            "workers_positive":"Well rated",
            "workers_mixed":"Mixed reviews",
            "workers_negative":"Poorly rated",
            "workers_notRated":"Not rated yet",
            "groupAlone":"The group alone",
            "group":"Group",
            "companiesOne":"{count} company",
            "companiesMany":"{count} companies",
            "clientsOne":"{count} client",
            "clientsMany":"{count} clients",
            "groupContactsTitle":"Group contacts ({count})",
            "add":"Add",
            "noPosition":"Position unknown",
            "allContacts":"See all contacts",
            "groupCompanies":"Companies of the group ({count})",
            "addCompany":"Add a company",
            "groupCompaniesEmptyTitle":"No company in this group",
            "groupCompaniesEmptyText":"Add one with the button above.",
            "groupCompaniesRange":"{from} to {to} of {count} companies",
            "groupBillingNoCompany":"Add a company to the group from its overview: its invoices will show here.",
            "noDepartment":"Department unknown",
            "missionsOne":"{count} mission",
            "missionsMany":"{count} missions",
            "lastExchange":"Exchange on {day}",
            "noExchange":"No exchange",
            "groupUpcomingEmptyText":"Upcoming meetings, tasks and callbacks of the group and its companies will show here.",
            "groupRecentEmptyText":"The latest calls, e-mails and notes of the group and its companies will show here.",
            "groupAndCompanies":"The group and its companies",
            "groupContactsEmptyTitle":"Nobody at group level",
            "groupContactsEmptyText":"Add those who decide for every company: HR, purchasing, management.",
            "editContact":"Edit {name}",
            "contactsOne":"{count} contact",
            "contactsMany":"{count} contacts",
            "companyNoContact":"No contact in this company.",
            "workingFor":"{count} companies",
            "information":"Information",
            "fieldEmail":"E-mail",
            "fieldPhone":"Phone",
            "fieldLead":"Lead status · for all their companies",
            "lead_none":"None",
            "lead_ambassadeur":"Ambassador",
            "ambassadorSet":"{name} is an ambassador",
            "ambassadorUnset":"Status removed",
            "groupContact":"Group contact",
            "notOnJobbiz":"Not on Jobbiz",
            "places":"Companies ({count})",
            "placesWithGroups":"Groups and companies ({count})",
            "inviteAt":"Invite to Jobbiz at {company}"
        },
        "mailComposer":{
            "newMessage":"New message",
            "minimize":"Minimise",
            "restore":"Reopen",
            "expand":"Full screen",
            "shrink":"Exit full screen",
            "close":"Close",
            "to":"To",
            "cc":"Cc",
            "bcc":"Bcc",
            "subject":"Subject",
            "message":"Message",
            "send":"Send",
            "discard":"Discard draft",
            "demoHint":"Demo: the e-mail is added to the activity, not sent.",
            "scheduleTitle":"Schedule send",
            "slot_tomorrowMorning":"Tomorrow morning",
            "slot_tomorrowAfternoon":"Tomorrow afternoon",
            "slot_mondayMorning":"Monday morning",
            "slot_custom":"Pick date and time",
            "timeLabel":"Time",
            "schedulePast":"Pick a time to come.",
            "back":"Back",
            "scheduleCta":"Schedule send",
            "sentToast":"E-mail added to the activity",
            "scheduledToast":"Send scheduled on {day} at {time}"
        },
        "recordActivity":{
            "emailScheduled":"E-mail scheduled to {address}",
            "cancelSend":"Cancel sending",
            "sendCanceled":"Sending canceled",
            "callBy":"Call by {name}",
            "callResult":{
                "answered":"Reached.",
                "callback":"To call back.",
                "no_answer":"No answer.",
                "not_interested":"Not interested."
            },
            "emailTo":"E-mail sent to {address}",
            "emailFrom":"E-mail from {address}",
            "emailHeaderSent":"From: {from} · To: {to} ({address})",
            "emailHeaderReceived":"From: {from} · To: {to}",
            "meetingWith":"Meeting with {name}",
            "meeting":"Meeting",
            "taskDoneBy":"Task done by {name}",
            "taskFor":"Task assigned to {name}",
            "taskDue":"Due: {day}",
            "noteBy":"Note by {name}",
            "client":{
                "mission_created":"created mission no. {number} · {title}",
                "mission_canceled":"cancelled mission no. {number} · {title}",
                "contract_signed":"signed the contract of {worker} · mission no. {number}",
                "timesheet_validated":"approved the timesheet of {worker} · {hours} h",
                "worker_review_positive":"left a positive review on {worker} · {job}",
                "worker_review_negative":"left a negative review on {worker} · {job}",
                "member_added":"added {member} to the company space"
            },
            "clientMany":{
                "mission_created":"{count} missions created",
                "mission_canceled":"{count} missions cancelled",
                "contract_signed":"{count} contracts signed",
                "timesheet_validated":"{count} timesheets approved",
                "worker_review":"{count} reviews left",
                "member_added":"{count} members added"
            },
            "clientBy":"by {who}",
            "people":"{count} people",
            "more":"See more",
            "less":"See less",
            "seeAll":"See all {count}",
            "unread":"Not read yet",
            "readOnce":"Read once · last read {day} at {time}",
            "readMany":"Read {count} times · last read {day} at {time}",
            "subject":"Subject: {subject}",
            "filter_all":"All",
            "filter_email":"E-mails",
            "filter_call":"Calls",
            "filter_task":"Tasks",
            "filter_note":"Notes",
            "filter_client":"Client actions",
            "add":"Add",
            "addTask":"A task",
            "addEvent":"An appointment",
            "upcoming":"Upcoming",
            "empty_all":"No activity",
            "empty_email":"No e-mail",
            "empty_call":"No call",
            "empty_task":"No task",
            "empty_note":"No note",
            "empty_client":"No action of the client",
            "emptyText_all":"Calls, e-mails, meetings, tasks and notes will show here, the latest first.",
            "emptyText_email":"E-mails sent and received will show here, with how often each was read.",
            "emptyText_call":"Logged calls will show here.",
            "emptyText_task":"Tasks and meetings will show here, upcoming then done.",
            "emptyText_note":"Notes taken on the record will show here.",
            "emptyText_client":"What the client does in Jobbiz will show here."
        },
        "recordForm":{
            "close":"Close",
            "cancel":"Cancel",
            "noteTitle":"Add a note",
            "noteCta":"Add the note",
            "noteLabel":"Note",
            "notePlaceholder":"What to remember…",
            "noteSaved":"Note added",
            "callTitle":"Call {name}",
            "callCta":"Log the call",
            "callHintOne":"{company}: call, then log how the call went.",
            "callHintMany":"Pick whom to call, then log how the call went.",
            "who":"Who",
            "resultLabel":"Result",
            "result_answered":"Reached",
            "result_callback":"To call back",
            "result_no_answer":"No answer",
            "result_not_interested":"Not interested",
            "callNote":"Note",
            "callNotePlaceholder":"What to remember of the talk…",
            "callSaved":"Call logged",
            "eventTitle":"Add a meeting",
            "eventCta":"Add the meeting",
            "eventWhat":"Subject",
            "eventWhatPlaceholder":"Quarterly review and needs for December",
            "day":"Date",
            "time":"Time",
            "timeError":"24-hour time, for example 14:30",
            "duration":"Duration",
            "duration_30":"30 min",
            "duration_45":"45 min",
            "duration_60":"1 h",
            "duration_90":"1 h 30",
            "duration_120":"2 h",
            "location":"Place",
            "locationPlaceholder":"Address of the meeting",
            "onSite":"On site",
            "with":"With",
            "description":"Description",
            "eventSaved":"Meeting added",
            "lostTitle":"Mark as lost",
            "lostCta":"Mark as lost",
            "reason":"Reason",
            "reason_price":"Price too high",
            "reason_competitor":"Chose another agency",
            "reason_noNeed":"No need before the season",
            "reason_direct":"Hires directly",
            "reason_unreachable":"Unreachable",
            "reason_closed":"Business closed",
            "reasonDetails":"Details",
            "relaunch":"Planned follow-up",
            "noRelaunch":"No follow-up",
            "lostSaved":"Company marked as lost",
            "deleteTitle":"Delete the company",
            "deleteCta":"Delete",
            "deleteWarning":"Only a prospect can be deleted: it leaves the list of companies.",
            "deleteReason":"Reason for deleting",
            "deleteReasonPlaceholder":"Pick a reason",
            "deleteReason_duplicate":"Duplicate of another company",
            "deleteReason_test":"Test sign-up",
            "deleteReason_spam":"Fake sign-up",
            "deleteReason_outOfScope":"Out of scope (does not hire temp workers)",
            "deleteReason_other":"Other",
            "deleteDetailsRequired":"Say why",
            "deleteSaved":"Company deleted",
            "toGroupTitle":"Make it a group",
            "toGroupCta":"Create the group",
            "groupName":"Group name",
            "toGroupHint":"A group of this name is created, and the company joins it.",
            "toGroupSaved":"Group created",
            "contactAddTitle":"Add a group contact",
            "contactEditTitle":"Edit the contact",
            "contactCta":"Save",
            "firstname":"First name",
            "lastname":"Last name",
            "position":"Position",
            "phone":"Phone",
            "email":"E-mail",
            "contactSaved":"Contact saved",
            "groupCompanyTitle":"Add a company to the group",
            "searchCompany":"Search a company",
            "groupCompanyCta":"Add",
            "groupCompanySaved":"{company} added to the group {group}",
            "groupCompanyNone":"No company outside a group matches."
        },
        "assign":{
            "unassigned":"Not assigned",
            "tooltip":"Assign",
            "me":"{name} (me)"
        },
        "comments":{
            "emptyTitle":"No comment",
            "emptyText":"Ask a question or say where you are; type @ to name a colleague.",
            "placeholder":"Add a comment… @ to name a colleague",
            "submit":"Comment",
            "at":"{day} at {time}",
            "someone":"Someone",
            "added":"Comment added",
            "sentWithMentionsOne":"Comment sent, {names} is named",
            "sentWithMentionsOther":"Comment sent, {names} are named"
        },
        "activity":{
            "at":"{day} at {time}"
        },
        "taskActivity":{
            "created":"Task created",
            "createdBy":"Task created by {name}",
            "done":"Marked as done",
            "doneBy":"Marked as done by {name}",
            "reopened":"Reopened",
            "reopenedBy":"Reopened by {name}",
            "updated":"Edited",
            "updatedBy":"Edited by {name}",
            "empty":"empty",
            "someone":"someone",
            "otherCompany":"another company",
            "field_title":"Title",
            "field_type":"Type",
            "field_note":"Description",
            "field_dueOn":"Due day",
            "field_dueTime":"Time",
            "field_durationMin":"Length",
            "field_assigneeId":"Assigned to",
            "field_companyId":"Company",
            "field_contactName":"Contact",
            "field_emailTemplate":"E-mail template",
            "field_emailSubject":"Subject",
            "field_emailBody":"Message"
        },
        "taskPanel":{
            "close":"Close",
            "loadError":"This task could not load.",
            "tabDetail":"Detail",
            "tabActivity":"Activity",
            "tabComments":"Comments",
            "fiche":"Record",
            "descriptionLabel":"Task description",
            "descriptionPlaceholder":"Describe the task…",
            "descriptionSaved":"Description saved",
            "emailSaved":"E-mail saved",
            "assigned":"Task assigned to {name}",
            "done":"Task completed",
            "reopened":"Task reopened",
            "emailSent":"E-mail sent",
            "deleted":"Task deleted",
            "undo":"Undo",
            "edit":"Edit the task",
            "delete":"Delete the task",
            "markDone":"Mark as done",
            "reopen":"Reopen the task",
            "doneOn":"Done on {day}",
            "call":"Call",
            "sendEmail":"Send the e-mail",
            "emailReady":"E-mail ready",
            "emailEditButton":"Edit",
            "emailEdit":"Edit the e-mail",
            "emailTemplateLabel":"Intercom template",
            "emailSubjectLabel":"Subject",
            "emailBodyLabel":"Message",
            "emailTemplate":"Template chosen by the AI: {template}",
            "emailNoTemplate":"to choose",
            "emailAi":"AI",
            "emailTo":"To: {to}",
            "emailTemplateHint":"Chosen by the AI from the description, can be changed.",
            "emailRemoveAttachment":"Remove {name}",
            "emailSubject":"Subject: {subject}",
            "emailEmpty":"The message is not written yet.",
            "cancel":"Cancel",
            "save":"Save"
        },
        "taskForm":{
            "close":"Close",
            "newTitle":"New task",
            "editTitle":"Edit the task",
            "newSubtitle":"Plan something to do.",
            "createdBy":"Created by {name} on {day}",
            "titleLabel":"Title",
            "noteLabel":"Description (optional)",
            "titleHint":"Proposed by the AI from the description, editable.",
            "noteLabel":"Task description",
            "noteHint":"The AI will draw the title of the task from it.",
            "noteHintEmail":"The AI will draw the title and choose the e-mail template.",
            "typeLabel":"Type",
            "typeMeeting":"Appointment",
            "typeHint_todo":"A simple action to tick, added to your tasks of the day.",
            "typeHint_call":"For a prospect, the call joins your prospecting call list of the day. For a client, it stays a task.",
            "typeHint_call_noProspect":"A call stays a task: it will show in your tasks of the day.",
            "typeHint_email":"On the day, the e-mail opens ready to send.",
            "typeHint_visit":"A visit on site, without a fixed time if need be.",
            "typeHint_meeting":"The appointment is added to your planning.",
            "typeHelp_todo":"A simple action to tick",
            "typeHelp_call":"A prospect joins the prospecting call list",
            "typeHelp_call_noProspect":"A call that stays a task of the day",
            "typeHelp_email":"Opens ready to send, with an Intercom template",
            "typeHelp_visit":"A visit on site",
            "typeHelp_meeting":"Added to your planning",
            "dayLabel":"Activity day",
            "timeLabel":"Time (optional)",
            "timeError":"24 h time, for instance 9:30",
            "today":"Today",
            "tomorrow":"Tomorrow",
            "monday":"Monday {day}",
            "durationLabel":"Length",
            "duration_15":"15 min",
            "duration_30":"30 min",
            "duration_45":"45 min",
            "duration_60":"1 h",
            "duration_90":"1 h 30",
            "duration_120":"2 h",
            "templateLabel":"Intercom template",
            "templateHint":"Chosen by the AI from the description, can be changed.",
            "assigneeLabel":"Activity assigned to",
            "assigneeNobody":"Nobody",
            "me":"{name} (me)",
            "contactLabelOptional":"Contact or company (optional)",
            "contactPlaceholder":"Search a company or a contact",
            "contactHint":"One record: company or contact.",
            "blockTitle":"Give the task a title.",
            "contactCall":"Call to {phone}",
            "contactEmail":"E-mail to {email}",
            "contactCallUnknown":"Call to an unknown number",
            "contactEmailUnknown":"E-mail to an unknown address",
            "contactChoose":"Choose",
            "contactPlaceholderScoped":"Search a contact",
            "contactNone":"No record",
            "contactNoResult":"No record found.",
            "contactScopeCompanyGroup":"{company}, its contacts and the companies of the group {group}.",
            "contactScopeCompany":"{company}, its contacts.",
            "contactScopeGroup":"{group}, its contacts and its companies.",
            "blockDescription":"Describe the task.",
            "blockCall":"Choose whom to call.",
            "blockEmail":"Choose whom to write to.",
            "blockTime":"Time as 9:30.",
            "cancel":"Cancel",
            "save":"Save",
            "busy":"One moment…",
            "ctaTodo":"Add the task",
            "addedTodo":"Task added",
            "whenTomorrow":" for tomorrow",
            "whenDay":" for {day}",
            "handed":"Task assigned to {name}",
            "saved":"Task saved",
            "deleted":"Task deleted",
            "duplicated":"Task duplicated",
            "copyOf":"{title} (copy)",
            "delete":"Delete",
            "duplicate":"Duplicate"
        },
        "taskTypes":{
            "todo":"To do",
            "call":"Call",
            "email":"E-mail",
            "visit":"Visit",
            "meeting":"Meeting"
        },
        "eventCategories":{
            "prospection":{"label":"Field visit","title":"Field visit"},
            "visite_client":{"label":"Client visit","title":"Client visit"},
            "rdv_client":{"label":"Client meeting","title":"Client meeting"},
            "embauche":{"label":"Hiring visit","title":"Hiring visit"},
            "presentation":{"label":"Presentation","title":"Jobbiz presentation"},
            "telephone":{"label":"Phone","title":"Phone appointment"},
            "interne":{"label":"Internal","title":"Internal meeting"}
        },
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "pennylanePush":{
            "alreadyOnPennylane":"Already on PennyLane",
            "skippedCount":"{count} already on PennyLane",
            "invoiceSkipped":"Invoice {number} is already on PennyLane: nothing was sent"
        },
        "name":'Ceci est un test',
        "slideOverCloseConfirm":{
            "addMission":"Are you sure you want to leave the mission creation? The information entered will be lost.",
            "addCompany":"Are you sure you want to leave the company creation? The information entered will be lost.",
            "qualification":"Are you sure you want to leave the qualification? Unsaved information will be lost."
        },
        "missionTasks":{
            "titleDe":"Tasks of the {title}",
            "titleElided":"Tasks of the {title}"
        },
        "missionDetail":{
            "tabs":{
                "mission":"Mission",
                "requirements":"Requirements",
                "tasks":"Tasks",
                "risk":"Position at risk"
            },
            "tasks":{
                "empty":"No task for this mission.",
                "added":"Added",
                "required":"Keep at least one task for the mission.",
                "tooMany":"A mission cannot keep more than 50 tasks.",
                "pending":"An added task is still being checked: wait for the check to end before confirming."
            },
            "risk":{
                "empty":"No risk factor for this mission.",
                "factorRequired":"Select at least one hardship factor for a position at risk."
            },
            "info":{
                "contact":"Manager",
                "contactName":"Name",
                "contactPoste":"Position",
                "contactNameRequired":"The manager's name is required.",
                "coefficient":"Billing coefficient",
                "coefficientUndefined":"Not set",
                "coefficientFromCompany":"Company value",
                "coefficientOverridden":"Changed for this mission",
                "coefficientCompanyValue":"(company: {value})",
                "coefficientReset":"Back to the company value",
                "coefficientEmptyHint":"Left empty, the coefficient follows the company grid: {value}.",
                "coefficientInvalid":"Enter a coefficient greater than 0 and lower than 10 (e.g. 1.85).",
                "coefficientFixBeforeConfirm":"Fix the billing coefficient before confirming.",
                "contactEmpty":"None"
            },
            "requirements":{
                "dressCode":"Dress code",
                "dressCodeEmpty":"None",
                "dressCodeTooLong":"The dress code cannot exceed 500 characters."
            },
            "changes":{
                "dressCode":"Dress code",
                "contact":"Manager",
                "toolProviders":"Tool providers",
                "tasks":"Tasks",
                "riskyPosition":"Position at risk",
                "coefficientCompany":"company value",
                "contactKeptOnContract":"The contract already generated keeps the former manager."
            }
        },
        "jobbizBackfill":{
            "offLabel":"Jobbiz does not backfill",
            "offTooltip":"The company turned off “Jobbiz backfills if needed”: do not offer the mission to other profiles nor look for a replacement."
        },
        "toolProviders":{
            "verb":{
                "company":"provided by",
                "temp_worker":"brought by"
            },
            "who":{
                "company":"the company",
                "temp_worker":"the temp worker"
            },
            "switchTo":{
                "company":"Switch to “provided by the company”",
                "temp_worker":"Switch to “brought by the temp worker”"
            },
            "providerLabel":"Provider of {name}: {who}",
            "remove":"Remove {name}",
            "removeTooltip":"Remove"
        },
        "missionHistory":{
            "sameTitle":"{count}x this job",
            "sameTitleDetail":"\"{title}\" missions already done: {count}",
            "sameTitleSameCompany":"Including for this client: {count}",
            "lastMission":"Latest: {company}, from {start} to {end}",
            "sameCompany":"{count}x this client",
            "sameCompanyDetail":"Missions already done for this client, any job: {count}",
            "conflict":"Already on a mission",
            "conflictDetail":"Assigned on dates overlapping this mission:",
            "conflictItem":"No. {number} {title} — {company}, from {start} to {end}"
        },
        "invoiceImport":{
            "modalTitle":"Import the invoices of {month}",
            "modalText":"Invoices not imported yet and those in error will be fetched from Bestt, then imported into Pennylane.",
            "cancel":"Cancel",
            "confirm":"Confirm",
            "confirming":"Starting…",
            "alreadyRunning":"An import of this month is already running: its progress is shown.",
            "periodInvalid":"This month cannot be imported.",
            "startFailed":"The import could not start, try again.",
            "stepBestt":"Step 1/2 · Fetching from Bestt",
            "stepPennylane":"Step 2/2 · Importing into Pennylane",
            "fetchedCount":"{done} / {total} invoices fetched",
            "importedCount":"{done} / {total} invoices imported",
            "finished":"Import finished",
            "finishedWithErrors":"Import finished with errors",
            "finishedWithErrorsCount":"{done} / {total} imported · {errors} in error",
            "failed":"Import failed",
            "fatal":{
                "ERR_BESTT_INDISPONIBLE":"Bestt does not answer: nothing was imported. Try again later.",
                "ERR_PASSAGE_INTERROMPU":"The import stopped. Try again: nothing will be imported twice.",
                "generic":"The import failed. Try again."
            },
            "close":"Close",
            "bannerTitle":"Import error",
            "bannerCountOne":"1 invoice could not be imported",
            "bannerCountMany":"{count} invoices could not be imported",
            "bannerLastRun":"last import on {date} at {time}",
            "bannerLastRunBy":"last import on {date} at {time} by {name}",
            "retryAll":"Retry all",
            "nothingToRetry":"No invoice of this month is in error anymore.",
            "retryFailed":"The retry could not start, try again.",
            "showJournal":"View the journal",
            "showErrors":"View the errors",
            "tooManyInvoices":"Too many invoices: use Retry all.",
            "journalNothingToRetry":"None of these invoices is in error anymore.",
            "informationSaving":"An invoice of this month is being saved, try again in a moment.",
            "listImportOne":"Import of 1 invoice",
            "listImportMany":"Import of {count} invoices",
            "bannerLastListRunOne":"last import of 1 invoice on {date} at {time}",
            "bannerLastListRunOneBy":"last import of 1 invoice on {date} at {time} by {name}",
            "bannerLastListRunMany":"last import of {count} invoices on {date} at {time}",
            "bannerLastListRunManyBy":"last import of {count} invoices on {date} at {time} by {name}"
        },
        "invoiceJournal":{
            "title":"Import journal · Bestt → Pennylane",
            "close":"Close",
            "moreActions":"More actions",
            "openJournal":"Import journal",
            "tabToFix":"To fix",
            "tabHistory":"History",
            "retryAll":"Retry all ({count})",
            "loading":"Loading the journal…",
            "loadFailed":"The journal could not be loaded",
            "reload":"Reload",
            "emptyTitle":"No invoice to fix",
            "emptyText":"No invoice of {month} is in error.",
            "headerOne":"1 invoice is in error. Fix its cause, then retry.",
            "headerMany":"{count} invoices are in error. They are grouped by cause: fix the cause, then retry.",
            "groupBesttOne":"1 invoice · stuck while fetching from Bestt",
            "groupBesttMany":"{count} invoices · stuck while fetching from Bestt",
            "groupPennylaneOne":"1 invoice · stuck while importing into Pennylane",
            "groupPennylaneMany":"{count} invoices · stuck while importing into Pennylane",
            "groupOne":"1 invoice",
            "groupMany":"{count} invoices",
            "stepBestt":"Step 1 · Bestt",
            "stepPennylane":"Step 2 · Pennylane",
            "showGroup":"Unfold",
            "hideGroup":"Fold",
            "howToFix":"How to fix",
            "invoiceLine":"No. {number} · {company}",
            "besttClient":"Bestt client {id}",
            "viewInvoice":"View the invoice",
            "pdfComesWithImport":"The PDF comes with the import",
            "code":"Code: {code}",
            "retryGroupOne":"Retry this invoice",
            "retryGroupMany":"Retry these {count} invoices",
            "and":" and ",
            "errors":{
                "ERR_BESTT_FACTURE_INTROUVABLE":{
                    "label":"Invoice not found in Bestt",
                    "explanation":"Bestt says it does not know these invoices.",
                    "fix":"Check these invoices in Bestt, then retry."
                },
                "ERR_BESTT_API":{
                    "label":"Bestt did not answer",
                    "explanation":"Bestt failed on these invoices.",
                    "fix":"Wait a few minutes, then retry."
                },
                "ERR_ENTREPRISE_INCONNUE_JOBBIZ":{
                    "label":"Bestt client without a Jobbiz company",
                    "explanation":"No Jobbiz company has this Bestt client.",
                    "fix":"Fill in the Bestt id on the company's page, then retry."
                },
                "ERR_ENTREPRISE_AMBIGUE_JOBBIZ":{
                    "label":"Bestt client linked to several companies",
                    "explanation":"Several Jobbiz companies have this Bestt client.",
                    "fix":"Leave this Bestt id to one company only, then retry."
                },
                "ERR_BESTT_PDF_INDISPONIBLE":{
                    "label":"PDF unavailable in Bestt",
                    "explanation":"Bestt did not return the PDF of these invoices.",
                    "fix":"Wait a few minutes, then retry."
                },
                "ERR_STOCKAGE_PDF":{
                    "label":"PDF not stored",
                    "explanation":"The PDF of these invoices could not be stored or read back.",
                    "fix":"Wait a few minutes, then retry."
                },
                "ERR_PENNYLANE_DESACTIVE":{
                    "label":"Sending to Pennylane disabled outside production",
                    "explanation":"Outside production, nothing is sent to Pennylane.",
                    "fix":"Nothing to fix: normal outside production."
                },
                "ERR_ENTREPRISE_INTROUVABLE_PENNYLANE":{
                    "label":"Company not found in Pennylane",
                    "explanation":"No Pennylane customer matches the company, and Jobbiz could not create it.",
                    "fix":"Jobbiz creates the customer when the company has a valid SIRET and a complete billing address: fix them on its profile, or create the customer in Pennylane with its SIRET, then retry."
                },
                "ERR_ENTREPRISE_AMBIGUE_PENNYLANE":{
                    "label":"Several Pennylane customers for the company",
                    "explanation":"Several Pennylane customers have the company's SIRET or SIREN.",
                    "fix":"Keep only one in Pennylane, then retry."
                },
                "ERR_FACTURE_AMBIGUE_PENNYLANE":{
                    "label":"Invoice duplicated or archived in Pennylane",
                    "explanation":"Pennylane holds the number of these invoices several times, or only as an archived version: Jobbiz cannot tell which one to follow.",
                    "fix":"In Pennylane, keep only one, not archived, then retry."
                },
                "ERR_TVA_TAUX_INCONNU":{
                    "label":"Unknown VAT rate",
                    "explanation":"The rate of {rates} applied to these invoices is not in Jobbiz's table.",
                    "explanationMany":"The rates of {rates} applied to these invoices are not in Jobbiz's table.",
                    "explanationNoRate":"The VAT rate of these invoices is not in Jobbiz's table.",
                    "fix":"Tell the tech team to add this rate, then retry."
                },
                "ERR_PENNYLANE_API":{
                    "label":"Pennylane refused or did not answer",
                    "explanation":"Pennylane refused these invoices or did not answer.",
                    "fix":"Wait a few minutes, then retry."
                },
                "ERR_PENNYLANE_CATEGORIE":{
                    "label":"Category not set in Pennylane",
                    "explanation":"These invoices are in Pennylane; a retry only sets the category.",
                    "fix":"Retry: only the category will be set."
                },
                "ERR_PENNYLANE_ECHEANCE":{
                    "label":"Due date not set in Pennylane",
                    "explanation":"These invoices were already in Pennylane; the due date chosen for them was not set there.",
                    "fix":"Retry: only the due date will be sent."
                },
                "ERR_PENNYLANE_ANNEXE":{
                    "label":"Appendix not sent to Pennylane",
                    "explanation":"These invoices are imported, but one of their appendices could not be sent to Pennylane.",
                    "fix":"If an appendix is \"to check in Pennylane\", look for it in Pennylane first: delete it in Jobbiz, and add it again if Pennylane does not have it. Then retry: only the pending appendices will be sent."
                }
            },
            "unknownError":{
                "explanation":"This error has no description in Jobbiz yet.",
                "fix":"Give the code to the tech team, then retry."
            },
            "history":{
                "startedAt":"{date} at {time}",
                "import":"Import",
                "listImportOne":"Import of 1 invoice",
                "listImportMany":"Import of {count} invoices",
                "retry":"Retry",
                "by":"by {name}",
                "inProgress":"running",
                "seconds":"{s} s",
                "minutes":"{m} min {s} s",
                "hours":"{h} h {m} min",
                "fetchedOne":"1 fetched",
                "fetchedMany":"{count} fetched",
                "importedOne":"1 imported",
                "importedMany":"{count} imported",
                "done":"Done",
                "inError":"{count} in error",
                "running":"Running",
                "failed":"Failed",
                "interrupted":"Interrupted",
                "fatal":{
                    "ERR_BESTT_INDISPONIBLE":"Bestt did not answer: nothing was imported.",
                    "ERR_PASSAGE_INTERROMPU":"Nothing will be imported twice at the next import.",
                    "generic":"The import failed."
                },
                "stepBestt":"1 · Fetching from Bestt",
                "stepPennylane":"2 · Importing into Pennylane",
                "stepFetchedOne":"1 invoice fetched",
                "stepFetchedMany":"{count} invoices fetched",
                "stepImportedOne":"1 invoice imported",
                "stepImportedMany":"{count} invoices imported",
                "toFixOne":"1 invoice to fix → see the To fix tab",
                "toFixMany":"{count} invoices to fix → see the To fix tab",
                "older":"Show older runs",
                "empty":"No import for this month"
            }
        },
        "invoiceDetail":{
            "kicker":"Client invoice",
            "title":"No. {number} · {company}",
            "titleLoading":"No. {number}",
            "besttClient":"Bestt client {id}",
            "tabInformation":"Information",
            "tabContacts":"Contacts",
            "tabHistory":"History",
            "tabComments":"Comments",
            "contactsNoCompany":"This invoice is not linked to any company.",
            "loading":"Loading the invoice…",
            "loadFailed":"The invoice could not be loaded.",
            "reloadFailed":"The invoice could not be read again, reload it.",
            "notFound":"This invoice cannot be found.",
            "reload":"Reload",
            "banner":{
                "notImportedTitle":"Invoice not imported yet",
                "notImportedText":"It will be saved in Jobbiz and imported into Pennylane at the next import.",
                "notImportedFetchedText":"It is saved in Jobbiz and will be imported into Pennylane at the next import.",
                "errorTitle":"{label} · {code}",
                "lateTitleOne":"Due date passed by 1 day",
                "lateTitleMany":"Due date passed by {days} days",
                "lateText":"Left to pay: {remaining} · due on {date}.",
                "lateTextNoRemaining":"Due on {date}."
            },
            "information":{
                "title":"Information",
                "amount":"Amount incl. tax",
                "period":"Period",
                "company":"Company",
                "category":"Category",
                "paymentTerm":"Payment term",
                "noCategory":"No category",
                "unknownCategory":"Category no. {id}",
                "categoryModified":"{value} · changed",
                "termModified":"{value} · changed",
                "termDefault":"{value} · default",
                "termDays":"{days} days",
                "atImport":"{value} · at import",
                "withDueDate":"{value} · due on {date}",
                "accountStatementNoCompany":"This invoice is not linked to any company."
            },
            "payment":{
                "title":"Payment",
                "remaining":"Left to pay",
                "paid":"Amount paid",
                "paidAt":"Paid on"
            },
            "companyTerms":{
                "loadFailed":"The company's terms could not be loaded.",
                "bonusesTitle":"Bonuses & allowances",
                "bonusName":"Name",
                "bonusUnit":"Unit",
                "bonusRate":"Rate",
                "noBonuses":"No bonus or allowance."
            },
            "preview":{
                "loading":"Loading the PDF…",
                "busy":"An import is running, try again in a moment.",
                "notFound":"The PDF of this invoice cannot be found.",
                "besttFailed":"Bestt did not return the PDF, try again in a moment.",
                "failed":"The preview could not be loaded.",
                "retry":"Try again",
                "rotate":"Rotate",
                "zoomOut":"Zoom out",
                "zoomIn":"Zoom in",
                "previousPage":"Previous page",
                "nextPage":"Next page",
                "pageOf":"{page} / {pages}",
                "fitWidth":"Fit to width",
                "expand":"Enlarge",
                "fullscreenTitle":"Invoice no. {number}",
                "download":"Download the PDF",
                "closeFullscreen":"Close the preview"
            },
            "footer":{
                "download":"Download the PDF",
                "import":"Import into Pennylane",
                "retry":"Retry the import",
                "running":"Import running…",
                "viewInPennylane":"View in Pennylane"
            },
            "messages":{
                "nothingToImport":"This invoice is already imported.",
                "nothingToRetry":"This invoice is no longer in error.",
                "importFailed":"The import could not start, try again.",
                "retryFailed":"The retry could not start, try again."
            }
        },
        "invoiceInformation":{
            "title":"Invoice information",
            "intro":"Applies to invoice no. {number} only, not to the company's other invoices.",
            "category":"Category",
            "noCategory":"No category",
            "unknownCategory":"Category no. {id}",
            "categoryOfTheCompany":"The company's category",
            "categoryOfCompany":"Category of {company}: {name}",
            "companyWithoutCategory":"{company} has no default category.",
            "paymentTerm":"Payment term",
            "paymentTermPlaceholder":"Choose a term",
            "termOfTheCompany":"The company's term",
            "termOfTheCompanyWithValue":"The company's term: {term}",
            "termOfCompany":"Term of {company}: {term}",
            "termDefault":"{term} (default)",
            "restore":"Restore",
            "cancel":"Cancel",
            "save":"Save",
            "saving":"Saving…",
            "saved":{
                "updated":"Saved in Jobbiz and in Pennylane.",
                "on_import":"Saved in Jobbiz; Pennylane will get it at import.",
                "skipped":"Saved in Jobbiz; Pennylane is not changed outside production.",
                "unchanged":"Saved in Jobbiz; nothing to change in Pennylane."
            },
            "errors":{
                "partialTitle":"Pennylane did not take every change.",
                "category":{
                    "saved":"Category: saved.",
                    "failed":"Category: not saved, Pennylane refused it or did not answer."
                },
                "paymentTerm":{
                    "saved":"Payment term: saved.",
                    "failed":"Payment term: not saved, Pennylane refused it or did not answer."
                },
                "PENNYLANE_INVOICE_NOT_FOUND":"This invoice cannot be found in Pennylane: what had to change there is not saved.",
                "PENNYLANE_INVOICE_AMBIGUOUS":"This invoice is duplicated or archived in Pennylane: what had to change there is not saved. In Pennylane, keep only one, not archived.",
                "IMPORT_ALREADY_RUNNING":"An import of this month is running: try again once it is over.",
                "INVOICE_INFORMATION_SAVING":"Another invoice of this month is being saved: try again in a moment.",
                "INVOICE_WITHOUT_COMPANY":"This invoice has no company: its category and term cannot be changed.",
                "generic":"Saving failed, try again."
            }
        },
        "invoiceAppendices":{
            "title":"Appendices",
            "add":"Add an appendix",
            "dropHere":"Drop an appendix here, or use the \"+\"",
            "accepted":"PDF, JPG or PNG · 10 MB max",
            "uploading":"Sending {name}…",
            "loading":"Loading the appendices…",
            "retry":"Try again",
            "by":"by {name}",
            "addedOn":"added on {date}",
            "download":"Download {name}",
            "delete":"Delete {name}",
            "confirm":"It is in Pennylane",
            "confirming":"Confirming…",
            "confirmed":"Appendix recorded as sent to Pennylane.",
            "unconfirmedHelp":"Pennylane did not answer when it was sent: it may be there. Look for it in Pennylane first. If it is there, confirm it here; otherwise, delete it and add it again.",
            "pennylaneUnavailable":"Pennylane appendices are unavailable for now.",
            "source":{
                "jobbiz":"Jobbiz",
                "pennylane":"Pennylane"
            },
            "status":{
                "sent":"Sent to Pennylane",
                "pending":"Waiting for the import",
                "unconfirmed":"To check in Pennylane"
            },
            "added":{
                "sent":"Appendix added and sent to Pennylane.",
                "pending":"Appendix added: it will be sent to Pennylane at the import.",
                "skipped":"Added in Jobbiz; nothing is sent to Pennylane outside production.",
                "other":"Appendix added."
            },
            "size":{
                "locale":"en-GB",
                "bytes":"{size} B",
                "kilobytes":"{size} KB",
                "megabytes":"{size} MB"
            },
            "deleteModal":{
                "title":"Delete the appendix",
                "text":"\"{name}\" will be deleted from Jobbiz.",
                "remainsInPennylane":"It will remain in Pennylane: deleting it here does not remove it from there. It will no longer be attached to Jobbiz emails.",
                "cancel":"Cancel",
                "confirm":"Delete",
                "deleting":"Deleting…",
                "deleted":"Appendix deleted.",
                "deletedRemains":"Appendix deleted from Jobbiz; it remains in Pennylane."
            },
            "errors":{
                "APPENDIX_FILE_MISSING":"No file received: drop a single, non-empty file.",
                "FILE_TOO_LARGE":"This file is over 10 MB.",
                "APPENDIX_FILE_TYPE_INVALID":"This file is neither a PDF, a JPG nor a PNG.",
                "APPENDIX_NOT_FOUND":"This appendix no longer exists: the list is read again.",
                "APPENDIX_FILE_NOT_FOUND":"The file of this appendix cannot be found in the storage.",
                "PENNYLANE_APPENDIX_FAILED":"Pennylane refused this appendix: nothing is kept.",
                "PENNYLANE_APPENDIX_UNCONFIRMED":"Pennylane did not answer: the appendix may have been added there. Check in Pennylane before dropping it again, or it would be there twice.",
                "APPENDIX_NOT_UNCONFIRMED":"This appendix no longer needs checking: the list is read again.",
                "INVOICE_APPENDIX_CONFIRM_FAILED":"The confirmation failed, try again.",
                "INVOICE_WITHOUT_COMPANY":"This invoice has no company: it takes no appendix.",
                "IMPORT_ALREADY_RUNNING":"An import of this month is running: try again once it is over.",
                "INVOICE_INFORMATION_SAVING":"Another invoice of this month is being saved: try again in a moment.",
                "PENNYLANE_INVOICE_NOT_FOUND":"This invoice cannot be found in Pennylane: the appendix is not added.",
                "PENNYLANE_INVOICE_AMBIGUOUS":"This invoice is duplicated or archived in Pennylane: the appendix is not added. In Pennylane, keep only one, not archived.",
                "INVOICE_NOT_FOUND":"This invoice cannot be found.",
                "loadFailed":"The appendices could not be loaded.",
                "addFailed":"Adding the appendix failed, try again.",
                "downloadFailed":"The file could not be downloaded, try again.",
                "pennylaneFile":{
                    "PENNYLANE_APPENDIX_FAILED":"The appendix could not be retrieved from Pennylane. Try again."
                },
                "deleteFailed":"The deletion failed, try again.",
                "confirmFailed":"The confirmation failed, try again.",
                "oneFileOnly":"Drop one file at a time."
            }
        },
        "invoiceErrors":{
            "ERR_BESTT_FACTURE_INTROUVABLE":{
                "explanation":"Bestt says it does not know this invoice.",
                "fix":"Check this invoice in Bestt, then retry."
            },
            "ERR_BESTT_API":{
                "explanation":"Bestt failed on this invoice.",
                "fix":"Wait a few minutes, then retry."
            },
            "ERR_ENTREPRISE_INCONNUE_JOBBIZ":{
                "explanation":"No Jobbiz company has the Bestt client of this invoice.",
                "fix":"Fill in the Bestt identifier on the company's page, then retry."
            },
            "ERR_ENTREPRISE_AMBIGUE_JOBBIZ":{
                "explanation":"Several Jobbiz companies have the Bestt client of this invoice.",
                "fix":"Leave this Bestt identifier on one company only, then retry."
            },
            "ERR_BESTT_PDF_INDISPONIBLE":{
                "explanation":"Bestt did not return the PDF of this invoice.",
                "fix":"Wait a few minutes, then retry."
            },
            "ERR_STOCKAGE_PDF":{
                "explanation":"The PDF of this invoice could not be stored or read back.",
                "fix":"Wait a few minutes, then retry."
            },
            "ERR_PENNYLANE_DESACTIVE":{
                "explanation":"Outside production, nothing is sent to Pennylane.",
                "fix":"Nothing to fix: normal outside production."
            },
            "ERR_ENTREPRISE_INTROUVABLE_PENNYLANE":{
                "explanation":"No Pennylane customer matches the company, and Jobbiz could not create it.",
                "fix":"Jobbiz creates the customer when the company has a valid SIRET and a complete billing address: fix them on its profile, or create the customer in Pennylane with its SIRET, then retry."
            },
            "ERR_ENTREPRISE_AMBIGUE_PENNYLANE":{
                "explanation":"Several Pennylane customers have the company's SIRET or SIREN.",
                "fix":"Keep only one of them in Pennylane, then retry."
            },
            "ERR_FACTURE_AMBIGUE_PENNYLANE":{
                "explanation":"Pennylane holds the number of this invoice several times, or only as an archived version: Jobbiz cannot tell which one to follow.",
                "fix":"In Pennylane, keep only one, not archived, then retry."
            },
            "ERR_TVA_TAUX_INCONNU":{
                "explanation":"The rate of {rate} applied to this invoice is not in Jobbiz's table.",
                "explanationNoRate":"The VAT rate of this invoice is not in Jobbiz's table.",
                "fix":"Ask the tech team to add this rate, then retry."
            },
            "ERR_PENNYLANE_API":{
                "explanation":"Pennylane refused this invoice or did not answer.",
                "fix":"Wait a few minutes, then retry."
            },
            "ERR_PENNYLANE_CATEGORIE":{
                "explanation":"This invoice is in Pennylane; a retry only sets the category.",
                "fix":"Retry: only the category will be set."
            },
            "ERR_PENNYLANE_ECHEANCE":{
                "explanation":"This invoice was already in Pennylane; the due date chosen for it was not set there.",
                "fix":"Retry: only the due date will be sent."
            },
            "ERR_PENNYLANE_ANNEXE":{
                "explanation":"This invoice is imported, but one of its appendices could not be sent to Pennylane.",
                "fix":"If an appendix is \"to check in Pennylane\", look for it in Pennylane first: delete it in Jobbiz, and add it again if Pennylane does not have it. Then retry: only the pending appendices will be sent."
            }
        },
        "invoiceHistory":{
            "loading":"Loading the history…",
            "empty":"No event",
            "notFound":"This invoice cannot be found: it has no history.",
            "loadFailed":"The history could not be loaded.",
            "retryLoad":"Retry",
            "at":"{date} at {time}",
            "by":"by {name}",
            "retryBy":"retry · by {name}",
            "retry":"retry",
            "automatic":"automatic",
            "migrated":"Taken over from the former import: earlier history unavailable",
            "unknownDate":"Unknown date",
            "transition":"{from} → {to}",
            "types":{
                "fetched":"Fetched from Bestt",
                "imported":"Imported into Pennylane",
                "import_failed":"Import error",
                "pennylane_category_set":"Category set in Pennylane",
                "category_changed":"Category changed",
                "payment_term_changed":"Payment term changed",
                "payment_status_changed":"Payment status changed",
                "appendix_added":"Appendix added",
                "appendix_sent":"Appendix sent to Pennylane",
                "appendix_deleted":"Appendix deleted",
                "sent_by_mail":"Invoice sent by email",
                "reminder_sent":"Reminder sent",
                "litigation_opened":"Moved to debt collection",
                "litigation_closed":"Out of debt collection",
                "reminders_suspended":"Automatic reminders suspended",
                "reminders_resumed":"Automatic reminders resumed",
                "comment_deleted":"Comment deleted",
                "unknown":"Other event"
            },
            "details":{
                "linked":"Linked: Pennylane already had this invoice",
                "sent":"Sent to Pennylane by Jobbiz",
                "customerCreated":"Customer created in Pennylane by Jobbiz",
                "noCategory":"No category",
                "unknownCategory":"Category no. {id}",
                "termDays":"{days} days",
                "newDueDate":"New due date on {date}",
                "sameDueDate":"Due date unchanged",
                "categoryPennylane":{
                    "updated":"Updated in Pennylane",
                    "on_import":"Will be set in Pennylane at import",
                    "skipped":"Pennylane not changed outside production"
                },
                "termPennylane":{
                    "updated":"Due date updated in Pennylane",
                    "on_import":"Due date sent to Pennylane at import",
                    "skipped":"Pennylane not changed outside production"
                },
                "appendix":{
                    "sent":"Sent to Pennylane",
                    "pending":"Waiting for the import",
                    "skipped":"Not sent to Pennylane outside production"
                },
                "remainsInPennylane":"It remains in Pennylane",
                "confirmedByAdmin":"Confirmed by an admin",
                "reminderLevel":{
                    "before_due":"Notice",
                    "first":"Reminder 1/3",
                    "second":"Reminder 2/3",
                    "third":"Reminder 3/3"
                },
                "reminderTrigger":{
                    "manual":"manual",
                    "auto":"automatic"
                },
                "recipientsOne":"{count} recipient",
                "recipientsMany":"{count} recipients",
                "redirected":"Sent to the test address: no client received it"
            }
        },
        "invoiceComments":{
            "tabWithCount":"Comments ({count})",
            "loading":"Loading the comments…",
            "empty":"No comment",
            "notFound":"This invoice cannot be found: it has no comments.",
            "loadFailed":"The comments could not be loaded.",
            "retryLoad":"Retry",
            "deletedAuthor":"Deleted account",
            "unnamedAuthor":"Unnamed author",
            "at":"{date} at {time}",
            "inputLabel":"Your comment",
            "placeholder":"Write a comment…",
            "submit":"Comment",
            "counter":"{count} / {max}",
            "tooLong":"A comment is 2,000 characters at most.",
            "errors":{
                "invalid":"The comment must be 1 to 2,000 characters long.",
                "notFound":"This invoice cannot be found: the comment was not saved.",
                "failed":"The comment could not be saved. Try again."
            },
            "deleteLabel":"Delete the comment",
            "deleteErrors":{
                "forbidden":"Only the author of the comment or a super-admin can delete it.",
                "failed":"The comment could not be deleted. Try again."
            },
            "edited":"edited",
            "editLabel":"Edit the comment",
            "editInputLabel":"Edit the comment",
            "editCancel":"Cancel",
            "editSubmit":"Save",
            "editErrors":{
                "invalid":"The comment must be 1 to 2,000 characters long.",
                "forbidden":"Only the author of the comment can edit it.",
                "failed":"The comment could not be edited. Try again."
            }
        },
        "invoiceSendMail":{
            "title":"Send by email",
            "open":"Send by email",
            "close":"Close",
            "intro":"The invoices are sent as PDF files to the billing contacts of each company.",
            "scopesLabel":"Invoices to send",
            "scope":{
                "selectionOne":"This invoice",
                "selectionOneDetail":"No. {number} · {company} · {amount}",
                "selectionMany":"These invoices",
                "selectionManyDetail":"{count} invoices selected",
                "company":"All the invoices of {company}",
                "group":"All the invoices of the {group} group",
                "invoicesOne":"{count} invoice",
                "invoicesMany":"{count} invoices",
                "companiesOne":"{count} company",
                "companiesMany":"{count} companies"
            },
            "recipients":{
                "title":"Recipients · billing contacts of {company}",
                "none":"No billing contact for this company.",
                "member":"Member",
                "pendingMember":"Invitation pending",
                "external":"External",
                "unnamed":"Unnamed contact"
            },
            "withoutCompany":"No company",
            "notSendable":{
                "title":"Left out, cannot be sent:",
                "item":"No. {number} · {status}"
            },
            "status":{
                "error":"Error",
                "draft":"Draft",
                "pending":"Pending",
                "partiallyPaid":"Partially paid",
                "paid":"Paid",
                "cancelled":"Cancelled",
                "notImported":"Not imported"
            },
            "loading":"Loading the invoices and the contacts…",
            "reload":"Try again",
            "cancel":"Cancel",
            "sendOne":"Send {count} invoice",
            "sendMany":"Send {count} invoices",
            "sending":"Sending…",
            "retrySend":"Retry the send",
            "frozenNotice":"The first send may have gone through: the selection is locked. Retry the identical send or close the window.",
            "entry":{
                "notSendable":"Only pending, partially paid or paid invoices can be sent by email.",
                "tooMany":"Send at most {max} invoices at a time"
            },
            "report":{
                "sentOne":"{count} invoice sent",
                "sentMany":"{count} invoices sent",
                "failedOne":"{count} invoice failed",
                "failedMany":"{count} invoices failed",
                "skippedOne":"{count} invoice skipped",
                "skippedMany":"{count} invoices skipped",
                "nothingSent":"No invoice sent",
                "replayed":"This send had already been made: nothing was sent again.",
                "line":"{company}: {reason}",
                "noRecipient":"no recipient ticked",
                "unknownCompany":"A company"
            },
            "companyErrors":{
                "INVOICE_PDF_MISSING":"the PDF of an invoice is missing",
                "APPENDIX_FILE_NOT_FOUND":"an appendix cannot be found",
                "ATTACHMENTS_TOO_LARGE":"the attachments exceed 20 MB",
                "BILLING_MAIL_SEND_FAILED":"the mail service refused the send",
                "INVOICE_MAIL_FAILED":"the send failed",
                "INVOICE_NOT_SENDABLE":{
                    "one":"{numbers} left out, cannot be sent",
                    "many":"{numbers} left out, cannot be sent"
                }
            },
            "errors":{
                "INVOICE_NUMBERS_INVALID":"This selection cannot be sent: 1 to 200 invoices at a time.",
                "SCOPE_INVALID":"This choice of invoices is not recognised.",
                "SCOPE_UNAVAILABLE":"This choice is no longer possible for this selection: pick another one.",
                "PERIOD_MIXED":"The selected invoices must be of the same month.",
                "SCOPE_TOO_LARGE":"Too many invoices for one send: 300 invoices and 30 companies at most.",
                "RECIPIENTS_INVALID":"A ticked recipient is no longer a billing contact of their company: close and reopen the window.",
                "NOTHING_TO_SEND":"No invoice that can be sent has a ticked recipient.",
                "REQUEST_ID_INVALID":"This send could not be identified: close and reopen the window.",
                "INVOICE_NOT_FOUND":"An invoice of the selection cannot be found.",
                "SEND_IN_PROGRESS":"This send is still in progress: wait, then try again. Nothing will be sent twice.",
                "BILLING_MAIL_DISABLED":"Sending emails is switched off on this environment.",
                "BILLING_MAIL_TEMPLATE_MISSING":"The invoice email template is missing on this environment.",
                "prepareFailed":"The invoices and the contacts could not be loaded.",
                "generic":"The send failed, try again.",
                "network":"The server did not answer. Try again: a send already gone will not be sent twice."
            }
        },
        "invoiceReminders":{
            "tabCount":"{count} to do",
            "remindAll":"Remind all",
            "remindAllRunning":"Reminding…",
            "cards":{
                "toDo":"To do",
                "late":"Late",
                "litigation":"Debt collection",
                "invoicesOne":"{count} invoice",
                "invoicesMany":"{count} invoices",
                "litigationValue":"{count} · {amount}",
                "unknown":"—"
            },
            "tabs":{
                "label":"Reminders",
                "todo":"To do",
                "upcoming":"Upcoming",
                "litigation":"Debt collection",
                "settled":"Settled"
            },
            "columns":{
                "number":"No.",
                "company":"Company",
                "remaining":"Left to pay",
                "late":"Late",
                "step":"To send",
                "passage":"Handed over",
                "status":"Status"
            },
            "row":{
                "invoiceOf":"Invoice {month}",
                "noCompany":"No company",
                "lateDaysOne":"{days} day",
                "lateDaysMany":"{days} days",
                "lateSince":"since {date}",
                "notLate":"Not late",
                "dueOn":"due on {date}",
                "nextOn":"on {date}",
                "remind":"Remind",
                "open":"Open",
                "moreActions":"More actions on invoice {number}",
                "suspend":"Suspend reminders",
                "resume":"Resume reminders"
            },
            "badges":{
                "before_due":"Notice",
                "first":"Reminder 1/3",
                "second":"Reminder 2/3",
                "third":"Reminder 3/3",
                "exhausted":"Reminders used up",
                "noRecipient":"No recipient",
                "suspended":"Suspended",
                "uncertain":"Uncertain send",
                "litigation":"Debt collection"
            },
            "badgeHints":{
                "noRecipient":"No \"Reminders\" contact in the company: nobody would receive the reminder.",
                "suspended":"The automatic reminders of this invoice are stopped.",
                "uncertain":"A send stayed in progress for over 10 minutes: check the history before reminding."
            },
            "suspension":{
                "suspended":"Automatic reminders suspended for invoice no. {number}.",
                "resumedNext":"Automatic reminders resumed for invoice no. {number}: next reminder on {date}.",
                "resumedNone":"Automatic reminders resumed for invoice no. {number}: no automatic reminder is planned.",
                "errors":{
                    "INVOICE_NOT_REMINDABLE":"This invoice is no longer reminded (settled, cancelled or in debt collection): the list is read again.",
                    "INVOICE_NOT_FOUND":"This invoice cannot be found.",
                    "generic":"The change could not be saved, try again."
                }
            },
            "list":{
                "loading":"Loading the reminders…",
                "loadFailed":"The list of reminders could not be loaded.",
                "retry":"Retry",
                "showingRange":"Showing {start}-{end} of {total} results",
                "showingAll":"Showing {total} results",
                "totalLate":"Total late: {amount}",
                "totalOwed":"Total left to pay: {amount}",
                "totalLitigation":"Total in debt collection: {amount}",
                "filteredEmptyTitle":"No invoice matches this search.",
                "clearSearch":"Clear the search",
                "empty":{
                    "todo":{
                        "title":"No invoice to remind",
                        "text":"Invoices with a reminder due will show here."
                    },
                    "upcoming":{
                        "title":"No upcoming reminder",
                        "text":"Unpaid invoices whose next reminder is not due yet will show here."
                    },
                    "litigation":{
                        "title":"No invoice in debt collection",
                        "text":"Invoices handed over to debt collection will show here."
                    },
                    "settled":{
                        "title":"No invoice settled after a reminder",
                        "text":"Invoices paid after at least one reminder will show here."
                    }
                }
            },
            "remindAllModal":{
                "title":"Remind all",
                "loading":"Counting the invoices to remind…",
                "loadFailed":"The invoices to remind could not be counted.",
                "retryLoad":"Retry",
                "intro":"Each \"To do\" invoice now gets its due reminder, PDF attached, sent to its \"Reminders\" contacts.",
                "countOne":"{count} invoice will be reminded:",
                "countMany":"{count} invoices will be reminded:",
                "nothing":"No \"To do\" invoice has a reminder to send.",
                "step":"{label}: {count}",
                "suspendedRule":"Suspended invoices are not reminded.",
                "suspendedOne":"{count} suspended invoice will not be reminded.",
                "suspendedMany":"{count} suspended invoices will not be reminded.",
                "exhaustedOne":"{count} invoice with its reminders used up has no reminder left to send.",
                "exhaustedMany":"{count} invoices with their reminders used up have no reminder left to send.",
                "triedRule":"A reminder already tried (failed or \"Uncertain send\") is not sent again: remind these invoices one by one.",
                "cancel":"Cancel",
                "confirm":"Remind all",
                "starting":"Starting…",
                "errors":{
                    "REMINDER_RUN_ALREADY_RUNNING":"A reminder run is already in progress.",
                    "BILLING_MAIL_DISABLED":"Sending emails is turned off on this environment.",
                    "BILLING_MAIL_TEMPLATE_MISSING":"The reminder email template is missing on this environment.",
                    "INVOICE_NUMBERS_INVALID":"The list of invoices to remind is not valid.",
                    "generic":"The run could not be started, try again."
                }
            },
            "run":{
                "alreadyRunning":"A reminder run is already in progress: its report will show at the end.",
                "done":"Remind all: run finished",
                "failed":"Remind all: the run stopped on a failure",
                "skipped":"Remind all: the run did not take place",
                "counters":"Sent: {sent} · failed: {failed} · no recipient: {noRecipient} · already settled: {settled} · already claimed: {alreadyClaimed}",
                "lost":"The run could no longer be followed: read the list again in a moment."
            },
            "reminderModal":{
                "title":"Send a reminder",
                "close":"Close",
                "summary":{
                    "number":"No. {number}",
                    "remaining":"{amount} left to pay",
                    "lateOne":"{days} day late",
                    "lateMany":"{days} days late",
                    "dueOn":"due on {date}"
                },
                "loading":"Preparing the reminder…",
                "reload":"Retry",
                "recipientsLabel":"Recipients",
                "recipients":{
                    "none":"No billing contact for this company.",
                    "member":"Member",
                    "pendingMember":"Invitation pending",
                    "external":"External",
                    "unnamed":"Unnamed contact"
                },
                "levelLabel":"Reminder template",
                "levels":{
                    "before_due":"Notice · Due soon",
                    "first":"Reminder 1/3 · Unpaid invoice",
                    "second":"Reminder 2/3 · Second notice",
                    "third":"Reminder 3/3 · Formal notice"
                },
                "levelLoading":"Loading the template…",
                "levelFailed":"This template could not be loaded: the previous one is kept, try again.",
                "messageLabel":"Message",
                "messageTooLong":"The message is over {max} characters ({count} typed).",
                "attachment":"The invoice PDF is attached automatically.",
                "suspend":"Suspend the automatic reminders for this invoice",
                "nextAutomatic":"Next automatic reminder planned on {date}.",
                "alreadySuspended":"The automatic reminders of this invoice are already suspended.",
                "cancel":"Cancel",
                "send":"Send the reminder",
                "sending":"Sending…",
                "retrySend":"Retry the send",
                "frozenNotice":"The first attempt may have gone through: the reminder is frozen. Retry the exact same send or close the window.",
                "sent":"Reminder sent for invoice No. {number}.",
                "sentSuspended":"Reminder sent for invoice No. {number}; its automatic reminders are suspended.",
                "replayed":"This reminder of invoice No. {number} had already been sent: nothing was sent again.",
                "draftErrors":{
                    "INVOICE_NOT_REMINDABLE":"This invoice is not reminded: settled, cancelled, a credit note, without a due date or not imported.",
                    "INVOICE_IN_LITIGATION":"This invoice is in debt collection: take it out of debt collection first to remind it.",
                    "INVOICE_NOT_FOUND":"This invoice cannot be found.",
                    "generic":"The reminder could not be prepared."
                },
                "errors":{
                    "INVOICE_SETTLED":"The invoice was settled in the meantime: no reminder was sent.",
                    "INVOICE_IN_LITIGATION":"This invoice is in debt collection: take it out of debt collection first to remind it.",
                    "INVOICE_NOT_REMINDABLE":"This invoice is no longer reminded (settled, cancelled or without a due date): no reminder was sent.",
                    "SEND_IN_PROGRESS":"This reminder is still being sent: wait, then try again. Nothing will be sent twice.",
                    "LEVEL_INVALID":"This reminder template is not recognised.",
                    "MESSAGE_INVALID":"The message must hold 1 to 5,000 characters.",
                    "RECIPIENTS_INVALID":"A ticked recipient is no longer a billing contact of the company: close and reopen the window.",
                    "REQUEST_ID_INVALID":"This send could not be identified: close and reopen the window.",
                    "INVOICE_NOT_FOUND":"This invoice cannot be found.",
                    "MAIL_SEND_FAILED":"The reminder email could not be sent: no reminder went out. You can try again; it will be a new send.",
                    "PENNYLANE_READ_FAILED":"The invoice status could not be read again in Pennylane: nothing was sent. Try again in a moment.",
                    "BILLING_MAIL_DISABLED":"Sending emails is turned off on this environment.",
                    "BILLING_MAIL_TEMPLATE_MISSING":"The reminder email template is missing on this environment.",
                    "generic":"The send failed, try again.",
                    "network":"The server did not answer. Try again: a reminder already sent will not be sent twice."
                }
            },
            "detail":{
                "remind":"Send a reminder"
            },
            "litigation":{
                "bannerTitleOne":"{count} invoice in debt collection",
                "bannerTitleMany":"{count} invoices in debt collection",
                "bannerText":"Automatic reminders are stopped. To hand over for debt collection.",
                "lastSent":"{label} on {date}",
                "noneSent":"No reminder sent",
                "since":"Since {date}",
                "start":"Move to debt collection",
                "end":"Take out of debt collection",
                "startModal":{
                    "title":"Move to debt collection",
                    "text":"Move invoice No. {number} to debt collection? Automatic and manual reminders stop until it is taken out.",
                    "cancel":"Cancel",
                    "confirm":"Move to debt collection",
                    "pending":"Moving…",
                    "done":"Invoice No. {number} has been moved to debt collection."
                },
                "endModal":{
                    "title":"Take out of debt collection",
                    "text":"Take invoice No. {number} out of debt collection? It goes back to the reminders, with no catching up: the steps already due go back to \"To do\" and wait for an admin.",
                    "cancel":"Cancel",
                    "confirm":"Take out of debt collection",
                    "pending":"Taking out…",
                    "doneNext":"Invoice No. {number} is out of debt collection. Next automatic reminder planned on {date}.",
                    "doneNone":"Invoice No. {number} is out of debt collection. No automatic reminder planned."
                },
                "errors":{
                    "INVOICE_NUMBER_INVALID":"This invoice number is not valid.",
                    "INVOICE_NOT_FOUND":"This invoice cannot be found.",
                    "ALREADY_IN_LITIGATION":"This invoice is already in debt collection.",
                    "INVOICE_SETTLED":"This invoice is settled or cancelled: it cannot be moved to debt collection.",
                    "INVOICE_NOT_LATE":"This invoice is not late: it cannot be moved to debt collection.",
                    "NOT_IN_LITIGATION":"This invoice is no longer in debt collection.",
                    "INVOICE_LITIGATION_FAILED":"The server could not save the change: nothing changed, try again.",
                    "forbidden":"You do not have access to invoices.",
                    "generic":"The change could not be saved, try again.",
                    "network":"No answer from the server: the change may have been saved. The list is being read again."
                }
            }
        },
        "invoiceList":{
            "tabInvoices":"Invoices",
            "tabReminders":"Reminders",
            "importButton":"Import",
            "columnNumber":"No.",
            "columnCompany":"Company",
            "columnAmount":"Amount incl. tax",
            "columnRemaining":"Left to pay",
            "columnStatus":"Status",
            "besttClient":"Bestt client {id}",
            "viewInvoice":"View the invoice",
            "status":{
                "error":"Error",
                "draft":"Draft",
                "pending":"Pending",
                "partiallyPaid":"Partially paid",
                "paid":"Paid",
                "cancelled":"Cancelled",
                "notImported":"Not imported"
            },
            "late":"Late · {days} d",
            "statusTooltip":{
                "notImported":"Not yet fetched from Bestt nor sent to Pennylane.",
                "draft":"Imported into Pennylane as a draft, not finalised yet.",
                "pending":"Finalised in Pennylane, awaiting payment.",
                "partiallyPaid":"{paid} paid · {remaining} left to pay.",
                "partiallyPaidPaidOnly":"{paid} paid.",
                "partiallyPaidRemainingOnly":"{remaining} left to pay.",
                "partiallyPaidUnknown":"Partly paid.",
                "paidOn":"Paid in full on {date}.",
                "paid":"Paid in full.",
                "late":"Due date of {date} passed.",
                "lateNoDate":"Due date passed.",
                "cancelled":"Cancelled in Pennylane, left out of the amounts to collect.",
                "error":"Import failed: {cause}.",
                "errorUnknown":"Import failed.",
                "errorCauses":{
                    "ERR_BESTT_FACTURE_INTROUVABLE":"Bestt does not know this invoice",
                    "ERR_BESTT_API":"Bestt failed on this invoice",
                    "ERR_ENTREPRISE_INCONNUE_JOBBIZ":"no Jobbiz company has this Bestt client",
                    "ERR_ENTREPRISE_AMBIGUE_JOBBIZ":"several Jobbiz companies have this Bestt client",
                    "ERR_BESTT_PDF_INDISPONIBLE":"Bestt did not return the PDF",
                    "ERR_STOCKAGE_PDF":"the PDF could not be stored or read back",
                    "ERR_PENNYLANE_DESACTIVE":"outside production, nothing is sent to Pennylane",
                    "ERR_ENTREPRISE_INTROUVABLE_PENNYLANE":"no Pennylane customer for this company",
                    "ERR_ENTREPRISE_AMBIGUE_PENNYLANE":"several Pennylane customers for this SIRET or SIREN",
                    "ERR_FACTURE_AMBIGUE_PENNYLANE":"several versions of this invoice in Pennylane, or only archived ones",
                    "ERR_TVA_TAUX_INCONNU":"unknown VAT rate",
                    "ERR_PENNYLANE_API":"Pennylane refused the invoice or did not answer"
                },
                "errorSentences":{
                    "ERR_PENNYLANE_CATEGORIE":"Invoice imported, but its category is not set.",
                    "ERR_PENNYLANE_ECHEANCE":"Invoice imported, but its due date is not set in Pennylane.",
                    "ERR_PENNYLANE_ANNEXE":"Invoice imported, but an appendix is not sent to Pennylane."
                }
            },
            "loadFailed":"The invoice list could not be loaded.",
            "retry":"Try again",
            "loading":"Loading invoices…",
            "emptyTitle":"No invoice for {month}",
            "emptyText":"The invoices of the month will show here as soon as they are generated. Change the month or your filters to see others.",
            "seeMonth":"See {month}",
            "showingRange":"Showing {start}-{end} of {total} results",
            "showingAll":"Showing {total} results",
            "total":"Total: {amount}",
            "searchScopeLabel":"Search in",
            "searchScope":{
                "all":"All",
                "company":"Company",
                "group":"Group",
                "number":"Invoice no."
            },
            "searchPlaceholder":"Search",
            "filteredEmptyTitle":"No invoice matches these filters.",
            "clearFilters":"Clear filters",
            "statusFilterLabel":"Status",
            "statusFilter":{
                "all":"All statuses",
                "late":"Late"
            },
            "selection":{
                "selectPage":"Select the invoices of the page",
                "selectInvoice":"Select invoice {number}",
                "barLabel":"Actions on the selection",
                "countOne":"1 invoice selected",
                "countMany":"{count} invoices selected",
                "retry":"Retry",
                "nothingToRetry":"No invoice of the selection is in error any more.",
                "sendByMail":"Send by email",
                "exportCsv":"Export CSV",
                "exportTooMany":"Export at most {max} invoices at a time",
                "exportFailed":"The CSV export failed, try again.",
                "exportPeriodInvalid":"This month cannot be exported.",
                "exportSelectionInvalid":"This selection cannot be exported."
            },
            "displayMode":{
                "label":"Display",
                "all":"All invoices",
                "byCompany":"By company",
                "byGroup":"By group"
            },
            "grouping":{
                "invoicesOne":"1 invoice",
                "invoicesMany":"{count} invoices",
                "companiesOne":"1 company",
                "companiesMany":"{count} companies",
                "groupRowsOne":"1 group or company",
                "groupRowsMany":"{count} groups or companies",
                "groupLabel":"Group",
                "noGroup":"No group",
                "noCompany":"No company",
                "unnamed":"Unnamed",
                "remainingPartial":"Left to pay known for only some of the invoices",
                "selectGroup":"Select the invoices of {name}",
                "selectFailed":"The invoices of {name} could not be selected, try again.",
                "unfold":"Unfold {name}",
                "fold":"Fold {name}",
                "status":{
                    "errorOne":"1 in error",
                    "errorMany":"{count} in error",
                    "lateOne":"1 late",
                    "lateMany":"{count} late",
                    "notImportedOne":"1 not imported",
                    "notImportedMany":"{count} not imported",
                    "draftOne":"1 draft",
                    "draftMany":"{count} drafts",
                    "pendingOne":"1 pending",
                    "pendingMany":"{count} pending",
                    "partiallyPaidOne":"1 partially paid",
                    "partiallyPaidMany":"{count} partially paid",
                    "paidOne":"1 paid",
                    "paidMany":"{count} paid",
                    "cancelledOne":"1 cancelled",
                    "cancelledMany":"{count} cancelled"
                }
            }
        },
        "unreadApplications":{
            "badgeOne":"1 new application since your last visit",
            "badgeOther":"{count} new applications since your last visit"
        },
        "inviteCandidates":{
            "lastMission":"Last mission:",
            "alreadyInvited":"Already invited"
        },
        "missionCreation":{
            "motifForm":{
                "titles":{
                    "customaryContract":"Customary fixed-term contract",
                    "replacement":"Replacement of an absent employee",
                    "activityIncrease":"Temporary increase in activity",
                    "awaitingRecruitment":"Awaiting recruitment",
                    "seasonal":"Seasonal employment"
                },
                "description":"Your description",
                "maxLengthHint":"250 characters",
                "lengthError":"Please write a message of more than 10 characters",
                "name":"Last name",
                "firstname":"First name",
                "replacedPosition":"Position replaced",
                "absenceDescription":"Describe precisely the reason for your employee's absence.",
                "date":"Date",
                "nameRequired":"Please enter a last name",
                "firstnameRequired":"Please enter a first name",
                "positionRequired":"Please enter a position",
                "nameMissing":"A last name is required",
                "firstnameMissing":"A first name is required",
                "dateMissing":"A date is required",
                "cancel":"Cancel",
                "confirm":"Confirm"
            }
        },
        "missionTemplate":{
            "createTitle":"New job description",
            "editTitle":"Edit job description",
            "saveButton":"Save the job description",
            "steps":{
                "activity":"Business sector",
                "risk":"Hazardous position",
                "prerequis":"Prerequisites",
                "tasks":"Tasks",
                "locationSalary":"Location & pay",
                "confirmation":"Confirmation"
            },
            "dressCode":{
                "label":"Dress code",
                "placeholder":"E.g. black trousers, plain white top, safety shoes",
                "tooLong":"The dress code must not exceed 500 characters"
            },
            "tools":{
                "label":"Required equipment"
            },
            "tasks":{
                "title":"Job tasks",
                "description":"Tick the suggested tasks or add your own.",
                "addPlaceholder":"Add a task (e.g. receiving deliveries)",
                "addButton":"Add",
                "selectedCountOne":"{count} task",
                "selectedCountOther":"{count} tasks",
                "selectedOfOne":"selected out of {total}",
                "selectedOfOther":"selected out of {total}",
                "addedByCompany":"Added by you",
                "noProposal":"No task suggested for this qualification. Add the temp worker's tasks.",
                "duplicate":"This task is already in the list.",
                "remove":"Remove {label}",
                "removeTooltip":"Remove",
                "checking":"Checking",
                "rejected":"“{label}” was not added: this text does not describe a job task.",
                "checkingBeforeSave":"Checking tasks…",
                "existingChecked":"“{match}” already exists: it has been ticked.",
                "existingListed":"“{match}” is already in the list: it was not added.",
                "addAsNewTask":"Add as a new task",
                "closeNotice":"Close",
                "notCheckedTooLong":"“{label}” could not be checked: add the tasks one at a time (80 characters at most).",
                "required":"Please keep at least one task"
            },
            "responsible":{
                "title":"On-site manager",
                "description":"The person the temp worker will contact on arrival."
            },
            "confirmation":{
                "title":"All good?",
                "description":"Review the job description before saving it. You can edit it later.",
                "edit":"Edit: {label}"
            },
            "summary":{
                "name":"Title",
                "activity":"Sector",
                "qualification":"Qualification",
                "riskyPosition":"Hazardous position",
                "tools":"Equipment",
                "licences":"Licences",
                "languages":"Language",
                "dressCode":"Dress code",
                "address":"Address",
                "salary":"Gross hourly rate",
                "contact":"Manager",
                "tasks":"Tasks"
            },
            "format":{
                "none":"None",
                "noTask":"None",
                "dressCodeMissing":"Not provided",
                "toolProvider":{
                    "company":"Company",
                    "temp_worker":"Temp worker"
                },
                "riskNo":"No",
                "riskYes":"Yes",
                "riskYesWith":"Yes · {factors}",
                "rate":"€{rate}",
                "rateIndexed":"€{rate} · indexed to the minimum wage",
                "contact":"{name} · {poste}",
                "tasksTwo":"{first} and {second}",
                "tasksMoreOne":"{first}, {second} and 1 other",
                "tasksMoreOther":"{first}, {second} and {count} others"
            },
            "mission":{
                "instructionsTitle":"Instructions",
                "instructionsDescription":"Specific to this mission, they do not change the job description.",
                "instructionsInterim":"For the temp worker",
                "instructionsInterimPlaceholder":"E.g. arrive 15 minutes early and ask for William at reception",
                "instructionsJobbiz":"For the Jobbiz team",
                "instructionsJobbizPlaceholder":"E.g. independent profile preferred",
                "summaryInterim":"Temp worker instructions",
                "summaryJobbiz":"Jobbiz instructions",
                "noInstructions":"None"
            }
        },
        "qualification":{
            "list":{
                "name":"Job title",
                "tasks":"Tasks",
                "sector":"Sector",
                "createdAt":"Created on",
                "disabled":"Disabled",
                "notInBestt":"The job has not been registered in BeSTT",
                "tasksCountOne":"{count} task",
                "tasksCountOther":"{count} tasks",
                "tasksCountZero":"0 tasks",
                "noTasksWarning":"No task: the job descriptions for this job will not suggest any",
                "create":"Create a qualification"
            },
            "slideOver":{
                "createTitle":"Create a qualification",
                "close":"Close",
                "editTitle":"Edit a qualification",
                "subtitle":"The job will get its own pool and will be offered when creating missions.",
                "editSubtitle":"Job sheet visible to temp workers. It also defines the related pool.",
                "editTasksSubtitle":"Tasks suggested to the company when it creates a mission for this job. It can remove some or add others.",
                "tabInformations":"Details",
                "tabTasks":"Tasks",
                "tabTasksWithCount":"Tasks ({count})",
                "tabRisk":"Hazardous job",
                "tabRequirements":"Requirements",
                "editRiskSubtitle":"State whether the job is hazardous and which factors apply. They will be carried over to the mission contract.",
                "editRequirementsSubtitle":"Equipment, PPE, licences and CACES needed for this job. They are carried over to missions by default.",
                "name":"Job title",
                "nameLocked":"The title can no longer be changed after creation",
                "description":"Description",
                "descriptionHint":"Introduce the job and its context. Tasks are managed in the Tasks tab.",
                "pcs":"PCS",
                "rome":"ROME",
                "sector":"Sector",
                "sectorPlaceholder":"Choose a sector",
                "sectors":{
                    "sale":"Sales",
                    "logistic":"Logistics",
                    "food":"Catering",
                    "largeDistribution":"Retail",
                    "administration":"Administration",
                    "industry":"Industry",
                    "other":"Other"
                },
                "missionPreferences":"Show in \"Mission preferences\"",
                "missionPreferencesHelp":"The temp worker will be able to add this job to their wish list.",
                "deactivate":"Disable",
                "activate":"Enable",
                "cancel":"Cancel",
                "confirm":"Confirm",
                "confirming":"Confirming...",
                "created":"The qualification has been created.",
                "updated":"The qualification has been updated.",
                "deactivated":"The qualification has been disabled.",
                "activated":"The qualification has been enabled.",
                "missingFields":"Please fill in all the fields.",
                "requiredField":"Required field",
                "errorInvalidTasks":"The tasks were rejected: check the labels (80 characters at most), the duplicates and the number of tasks (50 at most).",
                "errorNameImmutable":"The title can no longer be changed after creation.",
                "nameWillLock":"The title can no longer be changed after creation",
                "create":"Create",
                "errorInvalidPcs":"The PCS code was rejected: it must be 3 digits followed by a letter (e.g. 553C).",
                "errorInvalidRome":"The ROME code was rejected: it must be a letter from A to N followed by 4 digits (e.g. N1105), and exist in the ROME referential.",
                "errorInvalidAiSuggestion":"The AI proposal is no longer valid. Check the fields then click \"Create\" again: the qualification will be created without it.",
                "warningPcsNotInList":"The PCS code is not part of the PCS-ESE 2017 classification. It has been saved: please check it.",
                "errorRiskFactorRequired":"Select at least one risk factor, or state that the job is not hazardous.",
                "errorRiskFactorUnknown":"The risk factor \"{name}\" is not in the list. Uncheck it then save again.",
                "errorRiskFactorUnknownGeneric":"A checked risk factor is not in the list. Check the factors then save again.",
                "errorToolUnknown":"The PPE \"{name}\" is not in the equipment list. Remove it then save again.",
                "errorToolUnknownGeneric":"A chosen PPE is not in the equipment list. Check the PPE then save again.",
                "errorLicenceUnknown":"The licence \"{name}\" is not in the licence list. Remove it then save again.",
                "errorLicenceUnknownGeneric":"A chosen licence is not in the licence list. Check the licences then save again."
            },
            "tasks":{
                "newTask":"New task",
                "newTaskPlaceholder":"E.g. Clean the loading dock",
                "add":"Add",
                "empty":"No task for this job. Add some or use AI to suggest them.",
                "errorEmpty":"Enter a label.",
                "errorTooLong":"The label must not exceed {max} characters.",
                "errorDuplicate":"This task is already in the list.",
                "limitReached":"{max} tasks at most per job.",
                "editLabel":"Task label",
                "edit":"Edit {label}",
                "drag":"Move {label}",
                "remove":"Delete {label}",
                "editTooltip":"Edit",
                "dragTooltip":"Move",
                "removeTooltip":"Delete",
                "removeUsedOne":"This task is used in 1 job description. It will stay on it but will no longer be suggested.",
                "removeUsedOther":"This task is used in {count} job descriptions. It will stay on them but will no longer be suggested.",
                "renameUsedOne":"The new label will be applied to the job description that uses this task.",
                "renameUsedOther":"The new label will be applied to the {count} job descriptions that use this task.",
                "confirmRemove":"Delete",
                "confirmRename":"Rename",
                "cancel":"Cancel",
                "dragRoleDescription":"sortable item",
                "dragInstructions":"To move a task, press Space or Enter, use the up and down arrows, then Space or Enter to drop it, or Escape to cancel.",
                "dragStart":"Picked up task {label}.",
                "dragOver":"Task {label} moved over {over}.",
                "dragEnd":"Task {label} dropped.",
                "dragCancel":"Moving task {label} cancelled."
            },
            "risk":{
                "question":"Is this job hazardous?",
                "articleLink":"See article L. 4161-1 of the French Labour Code",
                "factorsLegend":"Risk factors that apply",
                "loading":"Loading risk factors…",
                "listError":"The risk factor list could not be loaded. Close and reopen the panel to try again.",
                "empty":"No risk factor in the list."
            },
            "requirements":{
                "tools":"PPE",
                "toolsPlaceholder":"Add equipment",
                "licences":"Licences",
                "licencesPlaceholder":"Add a licence or a CACES",
                "search":"Search",
                "noResult":"No result",
                "remove":"Remove {name}",
                "removeTooltip":"Remove",
                "loading":"Loading…",
                "toolsListError":"The equipment list could not be loaded. The PPE already chosen stay saved.",
                "licencesListError":"The licence list could not be loaded. The licences already chosen stay saved."
            },
            "ai":{
                "useAi":"Prefill with AI",
                "useAiHelp":"The AI fills in from the job title:",
                "generate":"Create and generate",
                "continue":"Continue",
                "titleLength":"For the AI, the job title must be between {min} and {max} characters long.",
                "generatingTitle":"The AI is preparing the job sheet",
                "generatingButton":"Generating…",
                "counterLabel":"Steps done: {done} of {total}",
                "steps":{
                    "description":"Description",
                    "sector":"Sector",
                    "tasks":"Default tasks",
                    "codes":"PCS and ROME codes",
                    "requirements":"Risky job and prerequisites"
                },
                "stepTitles":{
                    "description":"Description written",
                    "sector":"Sector identified",
                    "tasks":"Default tasks",
                    "codes":"PCS and ROME codes",
                    "requirements":"Risky job and prerequisites"
                },
                "stepDone":"Done",
                "stepPending":"In progress…",
                "stepWaiting":"Waiting",
                "stepRome":"ROME {code}",
                "stepPcs":"PCS {code}",
                "stepSentencesOne":"1 sentence about the job and its context",
                "stepSentencesOther":"{count} sentences about the job and its context",
                "stepTasksZero":"No task suggested",
                "stepTasksOne":"1 task suggested",
                "stepTasksOther":"{count} tasks suggested",
                "stepNotAtRisk":"Not a risky job",
                "stepFactorsOne":"1 risk factor",
                "stepFactorsOther":"{count} risk factors",
                "stepToolsOne":"1 PPE",
                "stepToolsOther":"{count} PPE",
                "stepLicencesOne":"1 licence",
                "stepLicencesOther":"{count} licences",
                "prefilled":"Prefilled by AI, check it before creating.",
                "regenerate":"Regenerate",
                "badge":"Suggested by AI",
                "markLabel":"AI",
                "failed":"Unable to suggest a qualification, fill in the fields manually.",
                "lowConfidence":{
                    "rome":"Low confidence in the suggested ROME code: check it or pick an alternative.",
                    "pcs":"Low confidence in the suggested PCS code: check it or pick an alternative."
                },
                "alternative":"{code} — {label}",
                "similarTitle":"Similar qualifications already exist",
                "similarHelp":"Check it does not exist before creating a new one.",
                "similarDisabled":"Disabled",
                "alternativeName":"Other suggested name: {name}",
                "useAlternativeName":"Use"
            },
            "regenerate":{
                "button":"Regenerate with AI",
                "loading":"Loading the qualification…",
                "before":"Before:",
                "suggested":"AI suggestion:",
                "restore":"Restore",
                "reapply":"Reapply the suggestion",
                "restoreField":"Restore the previous value: {field}",
                "reapplyField":"Reapply the AI suggestion: {field}",
                "emptyValue":"Not set",
                "notAtRisk":"Not a risky job",
                "atRisk":"Risky job",
                "summary":"Changed by AI: {fields}. Check then confirm to save.",
                "summaryNone":"The AI suggested no change."
            }
        },
        missionActivity: {
          perimeterChange: {
            title: 'changed the perimeter',
            field: 'Perimeter',
            none: 'None',
            unnamed: 'Unnamed',
            reasons: {
              manual: 'from the mission page',
              archive_transfer: 'original perimeter archived',
              duplicate: 'copy of a mission from an archived perimeter',
            },
          },
        },
        companyContacts: {
          tabLabel: 'Contacts',
          registered: {
            title: 'Registered on Jobbiz',
            add: 'Add',
            pending: 'Pending',
            resendInvitation: 'Resend the invitation',
            edit: 'Edit the contact',
            remove: 'Remove from the company',
            missingAccount: 'Account not found',
            removeMissingAccount: 'Remove the missing account',
          },
          hubspot: {
            title: 'HubSpot contacts',
            description:
              'Contacts of {company} in HubSpot who do not have a Jobbiz account yet.',
            refresh: 'Refresh the HubSpot contacts',
            collapse: 'Collapse the HubSpot contacts',
            expand: 'Expand the HubSpot contacts',
            invite: 'Invite',
            error: 'The HubSpot contacts could not be loaded.',
            retry: 'Retry',
          },
          perimeters: {
            title: 'Scopes',
            description:
              'Limits the access of managers to missions, contracts and timesheets. Without a scope, a member sees everything.',
            allMissions: 'All missions',
            collapse: 'Collapse the scopes',
            expand: 'Expand the scopes',
            list: {
              loadError: 'The scopes could not be loaded.',
              retry: 'Retry',
              create: 'Create',
              edit: 'Edit',
              archive: 'Archive',
              members: {
                one: '{count} member',
                many: '{count} members',
              },
              noMembers: 'No member attached',
            },
            empty: {
              title: 'No scope yet',
              description:
                'Without a scope, every manager sees every mission, contract and timesheet. Create scopes (a department, a site, a team...) to limit their access.',
            },
            form: {
              createTitle: 'Create a scope',
              createDescription:
                'Attach the members who will manage the missions of this scope. Members without a scope still see everything.',
              nameLabel: 'Scope name',
              namePlaceholder: 'E.g. Kitchen, Lamentin site, Night team',
              membersLabel: 'Attached members (optional)',
              searchPlaceholder: 'Search a member',
              noAssignableMember: 'No member to attach for now.',
              noSearchResult: 'No member matches your search.',
              create: 'Create',
              creating: 'Creating…',
              editTitle: 'Edit "{name}"',
              editDescription:
                'Changes apply right away to the access of the members.',
              save: 'Save',
              saving: 'Saving…',
            },
            modal: {
              cancel: 'Cancel',
            },
            delete: {
              title: 'Delete "{name}"?',
              description:
                'This scope is attached to no mission. It will be deleted for good.',
              confirm: 'Delete',
              deleting: 'Deleting…',
            },
            archive: {
              title: 'Archive "{name}"?',
              transferTitle: 'Archive "{name}"',
              finishedMissions: {
                one: 'The finished mission keeps this scope in its history.',
                many: 'The {count} finished missions keep this scope in their history.',
              },
              notProposed:
                'It will no longer be offered for new missions and you can restore it at any time.',
              activeMissions: {
                one: '{count} ongoing or upcoming mission',
                many: '{count} ongoing or upcoming missions',
              },
              transferIntro:
                '{missions} and {members} are attached to this scope. Finished missions keep it in their history.',
              transferLabel: 'Transfer the missions and the members to',
              noPerimeter: 'No scope',
              confirm: 'Archive',
              archiving: 'Archiving…',
              usageError: 'The access of the members concerned could not be checked.',
            },
            restore: {
              title: 'Restore "{name}"?',
              description: {
                one: 'This scope comes back without any member. Its finished mission will be restricted to it again: until you attach members, only administrators, directors and members without a scope will see it.',
                many: 'This scope comes back without any member. Its {count} finished missions will be restricted to it again: until you attach members, only administrators, directors and members without a scope will see them.',
              },
              restoring: 'Restoring…',
            },
            alert: {
              membersAccess: {
                one: 'The member concerned will have access to every mission, contract and timesheet.',
                many: 'The {count} members concerned will have access to every mission, contract and timesheet.',
              },
            },
            archived: {
              heading: 'Archived ({count})',
              archivedOn: 'Archived on {date}',
              finishedMissions: {
                one: '{count} finished mission',
                many: '{count} finished missions',
              },
              restore: 'Restore',
              loadError: 'The archived scopes could not be loaded.',
            },
            toast: {
              created: 'Scope created',
              updated: 'Scope updated',
              archived: 'Scope archived',
              deleted: 'Scope deleted',
              transferred: {
                one: '{count} mission transferred to {name}',
                many: '{count} missions transferred to {name}',
              },
              archivedNoPerimeter: {
                one: 'Scope "{name}" archived · {count} mission no longer has a scope',
                many: 'Scope "{name}" archived · {count} missions no longer have a scope',
              },
              restored: 'Scope "{name}" restored',
            },
            member: {
              restricted: 'Only sees the missions of these scopes.',
              none: 'None: sees every mission.',
              unrestricted: 'Always sees every mission',
              add: 'Add scopes',
              remove: 'Remove "{name}"',
              loading: 'Loading the scopes…',
              loadError: 'The scopes could not be loaded: they will not be changed.',
              saveFailed: 'Contact saved, but their scopes were not changed. {reason}',
              addModal: {
                title: 'Add scopes',
                description: 'Choose the scopes of {company} to attach {name} to.',
                searchPlaceholder: 'Search a scope',
                noPerimeterLeft: 'No other active scope to offer.',
                noSearchResult: 'No scope matches your search.',
                confirm: 'Confirm',
              },
              errors: {
                notRestrictable: 'A director or an administrator always sees every mission: their scopes cannot be changed.',
                notFound: 'One of the chosen scopes no longer exists: the list was refreshed.',
                archived: 'One of the chosen scopes has just been archived: the list was refreshed.',
                notLoaded: 'The list of scopes could not be read again: try again in a moment.',
              },
            },
            errors: {
              generic: 'An error occurred. Please try again.',
              nameRequired: 'The scope name is required.',
              nameTooLong: 'This name is too long.',
              nameTaken: 'A scope already has this name (active or archived).',
              memberInvalid: 'This member is no longer available: the list was refreshed.',
              notFound: 'This scope no longer exists.',
              archived: 'This scope is archived: restore it before editing it.',
              alreadyArchived: 'This scope is already archived.',
              notArchived: 'This scope is no longer archived.',
              inUse: 'This scope has already been attached to a mission: it can no longer be deleted, only archived.',
              transferInvalid: 'The chosen scope is no longer available for the transfer.',
              companyNotFound: 'This company no longer exists.',
            },
          },
          roles: {
            200: { label: 'Observer', description: 'The observer can only view the invoices, timesheets, contracts and missions created by the company.' },
            205: { label: 'Manager', description: 'The manager can only check timesheets.' },
            210: { label: 'Supervisor', description: 'The supervisor can sign contracts, import invoices, check timesheets and create missions.' },
            215: { label: 'Director', description: 'The director can sign contracts, import invoices, check timesheets, create missions and edit the company profile.' },
            220: { label: 'Coordinator', description: 'The coordinator can create missions and check timesheets.' },
            225: { label: 'Administrator', description: 'The administrator has every right of the director; they also manage the team and its permissions, and receive the company reminders.' },
          },
          edit: {
            back: 'Back to contacts',
            title: 'Edit the contact',
            subtitle: 'Information, scopes and notifications of this contact',
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            role: 'Role',
            cancel: 'Cancel',
            save: 'Save',
            saving: 'Saving…',
            saved: 'Contact saved.',
            savedInvitationFailed: 'Contact saved, but the invitation could not be sent. Resend it from the contact list.',
            pendingEmailChange: 'The invitation will be sent again to the new address.',
            activeEmailHint: 'The new address becomes their login right away; no e-mail tells them.',
            lastAdminWarning: 'The company will have no administrator left: its reminders and several of its emails will reach nobody.',
            errors: {
              required: 'This field is required.',
              nameTooLong: '35 characters at most.',
              emailInvalid: 'Invalid email address.',
              emailTaken: 'This address is already used by another account.',
              adminTaken: '{name} is already the administrator of this company.',
              adminTakenByMissingAccount: 'A missing account already holds the Administrator role. Remove it from the list before naming another one.',
              adminTakenUnknown: "Another member is already this company's administrator.",
              memberNotFound: 'This member is no longer part of the company.',
              generic: 'Something went wrong, please try again or contact support.',
            },
            notifications: {
              title: 'Notifications',
              name: 'Name',
              perimeter: 'Scope',
              all: 'All',
              checkboxLabel: '{type}: {column}',
              loading: 'Loading the notifications…',
              loadError: 'The notifications could not be loaded: they will not be changed.',
              retry: 'Retry',
              unrestrictedHint: 'A director or an administrator is notified for every mission: the Scope column does not apply.',
              noPerimeterHint: 'This contact has no scope: “Scope” means “All” until they are attached to a scope.',
              types: {
                invoices: { label: 'Invoice', description: 'New invoice issued' },
                reminders: { label: 'Invoice reminders', description: 'Due date reminders and unpaid invoice follow-ups' },
                contracts: { label: 'Contracts', description: 'New contracts to sign' },
                timesheets: { label: 'Timesheets', description: 'Timesheets to check' },
                missions: { label: 'Missions', description: 'Assignment, cancellation and end of missions' },
              },
              saveFailed: 'Contact saved, but their notifications were not changed. {reason}',
              errors: {
                generic: 'Something went wrong. Please try again.',
                forbidden: 'Your account is not allowed to change the notifications of this contact.',
                companyNotFound: 'This company cannot be found.',
                memberInvalid: 'This contact cannot be found.',
                typeInvalid: 'One of the subjects sent is not recognised: reload the sheet, then try again.',
                levelInvalid: 'The Scope level applies neither to invoices nor to a director or an administrator: check the notifications.',
              },
            },
          },
          removal: {
            lastAdminWarning: 'This member is the company administrator: without them, its reminders and several of its emails will reach nobody.',
            missingAccountConfirm: 'Remove this missing account from the company?',
          },
          resend: {
            alreadyActive: 'This member has already activated their account: the invitation is no longer needed.',
            failed: 'The invitation could not be sent again, please try again.',
          },
          invite: {
            title: 'Invite to Jobbiz',
            description: '{name} will receive an email to create their account.',
            hubspotDescription:
              '{name} will receive an email to create their account. Their details come from HubSpot.',
            someone: 'The invited person',
            email: 'Email',
            firstName: 'First name',
            lastName: 'Last name',
            phone: 'Phone number (optional)',
            role: 'Role',
            cancel: 'Cancel',
            send: 'Send the invitation',
            sending: 'Sending…',
            sent: 'Invitation sent.',
            attached: 'Existing account added to the company.',
            sentMailFailed:
              'Contact added, but the invitation could not be sent. Resend it from the contacts list.',
            attachedMailFailed:
              'Account added, but the email telling them could not be sent.',
            errors: {
              phoneInvalid: 'Invalid phone number.',
              alreadyMember: 'This person is already a member of the company.',
              tempWorker: 'This address belongs to a temp worker account.',
              companyNotFound: 'This company no longer exists.',
            },
            perimeters: {
              steps: 'Invitation steps',
              information: 'Information',
              notifications: 'Notifications',
              next: 'Next',
              label: 'Scopes',
              none: 'None · all missions',
              unrestricted: 'Always sees every mission',
              empty: 'No active scope.',
              loadError:
                'The company’s scopes could not be loaded: without a scope, the invited person will see every mission.',
              reloadError:
                'The scope list could not be read again: it may still offer a scope that no longer exists.',
              retry: 'Retry',
              errors: {
                notRestrictable:
                  'A director or an administrator always sees every mission: they cannot be attached to a scope.',
                notFound:
                  'One of the chosen scopes no longer exists: the list was refreshed. The invitation was not sent.',
                archived:
                  'One of the chosen scopes was just archived: the list was refreshed. The invitation was not sent.',
              },
            },
            notifications: {
              noPerimeterHint: 'Without a scope, “Scope” means “All”: this contact will only be notified for their own scopes once they have one.',
              errors: {
                typeInvalid:
                  'One of the notification subjects is not recognised: reload the page, then try again. The invitation was not sent.',
                levelInvalid:
                  'The Scope level applies neither to invoices nor to a director or an administrator: check the notifications. The invitation was not sent.',
              },
            },
          },
          activity: {
            emptyTitle: 'No change recorded',
            emptyText: 'Changes made to this company will show up here.',
            hubspot: {
              updated: 'HubSpot updated',
              notFound: 'No HubSpot contact with this address',
              failed: 'HubSpot update failed',
            },
            invitation: {
              resent: 'Invitation resent to the new address',
              failed: 'The invitation could not be resent',
              fromHubspot: 'From HubSpot',
              notSent: 'The email could not be sent',
            },
          },
        },
        "companyBilling":{
            "cardTitle":"Billing information",
            "billingAddress":"Billing address",
            "paymentTerm":"Payment term",
            "notSet":"Not set",
            "loadError":"The billing information could not be loaded.",
            "modalTitle":"Billing information",
            "modalIntro":"They apply to every invoice of the company. An invoice can have another term, from its detail.",
            "companyAddressHint":"Company address",
            "companyAddressPrefix":"Company address: {address}",
            "noCompanyAddress":"The company has no address.",
            "restore":"Restore",
            "paymentTermPlaceholder":"Choose a term",
            "currentPaymentTerm":"Currently: {term}",
            "defaultPaymentTerm":"{term} · default",
            "cancel":"Cancel",
            "save":"Save",
            "saving":"Saving…",
            "saved":"Billing information saved.",
            "savedBesttFailed":"Saved, but BeSTT was not updated: invoices will print the former address.",
            "besttNotUpdated":"BeSTT was not updated",
            "errors":{
                "BILLING_ADDRESS_INVALID":"Incomplete address: street, 5-digit postcode and city.",
                "PAYMENT_TERM_INVALID":"Invalid payment term.",
                "COMPANY_NOT_FOUND":"Company not found.",
                "generic":"Something went wrong, try again."
            },
            "paymentTerms":{
                "onReceipt":"On receipt",
                "days15":"15 days",
                "days30":"30 days",
                "days30EndOfMonth":"30 days end of month",
                "days45":"45 days",
                "days45EndOfMonth":"45 days end of month",
                "days60":"60 days"
            }
        },
        "companyOverview":{
            "address":"Address"
        },
        "companyBillingHistory":{
            "cardTitle":"Billing history",
            "previousYear":"Previous year",
            "nextYear":"Next year",
            "columnPeriod":"Period",
            "columnNumber":"No.",
            "columnAmount":"Amount incl. VAT",
            "columnPayment":"Payment",
            "openInvoice":"View invoice {number}",
            "loading":"Loading…",
            "empty":"No invoice in {year}",
            "loadError":"The billing history could not be loaded.",
            "retry":"Try again",
            "columnCompany":"Company",
            "groupEmpty":"No invoice in {year} for the group's companies",
            "groupPartialError":"The invoices of {names} could not be loaded.",
            "groupTotalOne":"Total {year}: {amount} incl. VAT over {count} invoice",
            "groupTotalMany":"Total {year}: {amount} incl. VAT over {count} invoices",
            "groupRemaining":"of which {amount} still to pay"
        },
        "accountStatement":{
            "button":"Account statement",
            "title":"Account statement",
            "intro":"The entries of the company's customer account at Pennylane over the period, starting from the balance on the first day.",
            "from":"From",
            "to":"To",
            "datePlaceholder":"dd/mm/yyyy",
            "cancel":"Cancel",
            "download":"Download the PDF",
            "sendMail":"Send by email",
            "sending":"Sending…",
            "sentOne":"Account statement sent to {count} recipient",
            "sentMany":"Account statement sent to {count} recipients",
            "sentRedirected":"Account statement sent to the test address: the contacts did not receive it.",
            "recipientsLoading":"Loading the billing contacts…",
            "recipientsLoadFailed":"The billing contacts could not be loaded.",
            "recipientsRetry":"Retry",
            "errors":{
                "customerNotFound":"This company is not linked to a Pennylane customer.",
                "pennylaneUnavailable":"Pennylane is not responding, try again in a few minutes.",
                "readsDisabled":"Reading from Pennylane is disabled on this environment.",
                "tooLarge":"This account has too many entries to generate the statement (more than 5,000 lines).",
                "invalidPeriod":"The period is invalid.",
                "forbidden":"You do not have access to the account statement.",
                "failed":"The statement could not be generated.",
                "recipientsInvalid":"A ticked recipient is no longer a billing contact: close and reopen the window.",
                "mailDisabled":"Sending emails is disabled on this environment.",
                "mailFailed":"The email could not be sent, try again.",
                "mailNetwork":"The server did not answer: the email may already have been sent."
            }
        },
        "panelCard":{
            "edit":"Edit {title}",
            "fold":"Fold {title}",
            "unfold":"Unfold {title}"
        },
        "companyBillingContacts":{
            "card":{
                "title":"Notifications",
                "add":"Add a recipient",
                "edit":"Edit {name}",
                "loading":"Loading recipients…",
                "loadError":"The invoice recipients could not be loaded.",
                "retry":"Retry",
                "nobody":"Nobody receives the invoices or the reminders.",
                "groups":{
                    "members":{
                        "title":"Registered on Jobbiz",
                        "info":"Members of the company, with a Jobbiz account, who receive the invoices or the reminders.",
                        "empty":"No member receives the invoices or the reminders."
                    },
                    "externals":{
                        "title":"Not registered on Jobbiz",
                        "info":"People without a Jobbiz account, added only to receive the invoices or the reminders.",
                        "empty":"No contact without an account."
                    }
                },
                "receives":{
                    "both":"Invoices, reminders",
                    "invoices":"Invoices",
                    "reminders":"Reminders",
                    "none":"No notification"
                },
                "memberStatus":{
                    "pending":"Invitation pending"
                }
            },
            "add":{
                "title":"Add a billing contact",
                "loading":"Loading members…",
                "loadError":"The members of the company could not be loaded.",
                "retry":"Retry"
            },
            "picker":{
                "intro":"Pick a member of the company or add a billing contact without a Jobbiz account. The invoices will be sent to them by email.",
                "searchLabel":"Search for a member or type an email address",
                "searchPlaceholder":"First name, last name or email",
                "membersGroup":"Members of the company",
                "alreadyRecipient":"Already a recipient",
                "noMember":"No member matches the search.",
                "addExternal":"Add “{query}” as a billing contact",
                "addExternalHint":"Receives the invoices by email, without a Jobbiz account"
            },
            "member":{
                "editTitle":"Edit the billing contact",
                "remove":"Remove from recipients"
            },
            "external":{
                "editTitle":"Edit the billing contact",
                "description":"This person will receive the invoices by email, without a Jobbiz account. They will also be added to HubSpot.",
                "email":"Email",
                "firstName":"First name",
                "lastName":"Last name",
                "phone":"Phone number (optional)",
                "invite":"Invite to Jobbiz",
                "delete":"Delete this contact",
                "deleteTitle":"Delete {name}?",
                "deleteConfirmation":"They will no longer receive the invoices or the reminders.",
                "confirmDelete":"Delete",
                "deleting":"Deleting…"
            },
            "notifications":{
                "label":"Notifications",
                "invoices":"Invoices",
                "invoicesHint":"New invoice issued",
                "reminders":"Reminders",
                "remindersHint":"Due date reminders and unpaid invoice reminders"
            },
            "actions":{
                "add":"Add",
                "back":"Back",
                "cancel":"Cancel",
                "save":"Save",
                "saving":"Saving…"
            },
            "toasts":{
                "added":"Billing contact added.",
                "saved":"Billing contact saved.",
                "removed":"Removed from recipients.",
                "deleted":"Billing contact deleted."
            },
            "errors":{
                "required":"This field is required.",
                "nameTooLong":"35 characters at most.",
                "emailInvalid":"Invalid email address.",
                "phoneInvalid":"Invalid number.",
                "contactIsMember":"This address belongs to a member of the company: pick them in the search.",
                "contactExists":"This address is already a billing contact of the company.",
                "notificationsEmpty":"Check at least one box: Invoices or Reminders.",
                "notificationsInvalid":"These notifications are not valid.",
                "contactNotFound":"This billing contact no longer exists.",
                "memberNotFound":"This member is no longer part of the company.",
                "companyNotFound":"Company not found.",
                "generic":"An error occurred, please try again."
            },
            "activity":{
                "ajouter_contact_facturation":"added the billing contact",
                "modifier_contact_facturation":"edited the billing contact",
                "supprimer_contact_facturation":"deleted the billing contact",
                "fields":{
                    "email":"Email",
                    "firstname":"First name",
                    "lastname":"Last name",
                    "phone":"Phone number",
                    "invoices":"Invoices",
                    "reminders":"Reminders"
                },
                "line":"{field}: {before} → {after}",
                "yes":"Yes",
                "no":"No",
                "empty":"—"
            }
        },
        "postIt":{
            "title":"Post-it",
            "where":"This note shows on the company sheet, the timesheet detail, the mission detail, the contract preview and the invoice detail.",
            "label":"Content",
            "placeholder":"Entry particularity, contact to notify…",
            "clearHint":"Clear the field to remove the post-it.",
            "loadFailed":"The post-it could not be loaded. Close and try again.",
            "cancel":"Cancel",
            "confirm":"Confirm",
            "saving":"Confirming ...",
            "saved":"The post-it has been saved",
            "saveFailed":"Saving failed"
        },
        "visaComplementary":{
            "types":{
                "new_permit":"New residence permit",
                "receipt":"Renewal receipt",
                "anef_extension":"Processing extension certificate (ANEF)"
            },
            "item":{
                "endValidity":"Valid until {date}",
                "noEndValidity":"End date not confirmed",
                "sentOn":"Sent on {date}",
                "open":"Open the proof"
            },
            "modal":{
                "title":"Extension proof",
                "notFound":"This proof cannot be found on the profile.",
                "documentType":"Proof type",
                "empty":"—",
                "currentPermitEnd":"Current permit ends",
                "endValidityLabel":"Valid until"
            },
            "toasts":{
                "accepted":"Proof validated",
                "endValidityRequired":"Enter a valid end of validity date."
            },
            "errors":{
                "badState":"This proof has already been handled: reopen the profile to see its state.",
                "invalidEndValidity":"The end of validity date is not valid.",
                "reasonNotFound":"This refusal reason no longer exists: choose another one.",
                "notFound":"This proof cannot be found on the profile.",
                "generic":"An error occurred, please try again."
            }
        },
        "licenceValidation":{
            "documentType":{
                "label":"Document type",
                "identity":"Identity",
                "identityDescription":"ID document, selfie, residence permit, health insurance card, proof",
                "licence":"Licences/CACES",
                "licenceDescription":"Driving licences and CACES certificates"
            },
            "tabs":{
                "pending":"Pending",
                "validated":"Validated by AI"
            },
            "categoryLabel":"category {category}",
            "status":{
                "pending":"To check",
                "accepted":"Validated",
                "refused":"Refused"
            },
            "verify":"Check {licence}",
            "openTempWorker":"View profile",
            "footer":{
                "pendingOne":"Showing {shown} temp worker of {total} ({pending} licences/CACES to check in total)",
                "pendingMany":"Showing {shown} temp workers of {total} ({pending} licences/CACES to check in total)",
                "validated":"Showing {shown} licences/CACES of {total}"
            },
            "empty":{
                "pendingTitle":"No licence/CACES to check",
                "pendingDescription":"Licences and CACES sent by temp workers will show up here.",
                "validatedTitle":"No licence/CACES validated by the AI",
                "validatedDescription":"Licences and CACES accepted by the AI will show up here.",
                "searchTitle":"No results",
                "searchDescription":"No licence/CACES matches your search."
            },
            "error":{
                "title":"Loading failed",
                "description":"The list of licences/CACES could not be loaded.",
                "retry":"Retry"
            },
            "modal":{
                "otherDocuments":"Other documents",
                "replaced":"Replaced",
                "drivingLicence":"Driving licence",
                "caces":"CACES",
                "subtitle":"{licence} · {pages}",
                "pages":{
                    "single":"single document",
                    "double":"front & back",
                    "many":"several documents"
                },
                "rotate":"Rotate a quarter turn",
                "licenceLabel":"Licence / CACES",
                "licencePlaceholder":"Choose a licence or a CACES",
                "expirationLabel":"Expiry date",
                "clearExpiration":"Clear the date",
                "expirationRequiredHint":"A CACES cannot be accepted without an expiry date.",
                "aiTitle":"Automatic analysis",
                "accept":"Accept",
                "refuse":"Refuse",
                "notFound":"This licence cannot be found on the profile.",
                "readOnly":{
                    "accepted":"This licence has been validated.",
                    "refused":"This licence has been refused: {reason}",
                    "refusedNoReason":"This licence has been refused.",
                    "replaced":"This licence was replaced on {date} by a new upload.",
                    "replacedNoDate":"This licence was replaced by a new upload."
                }
            },
            "toasts":{
                "accepted":"Licence validated.",
                "refused":"Licence refused.",
                "reasonRequired":"Choose a refusal reason."
            },
            "errors":{
                "expirationRequired":"A CACES cannot be accepted without an expiry date.",
                "notPending":"This licence has already been handled: close the window to see its state.",
                "notInCatalogue":"This licence is not in the catalogue: choose another one.",
                "notFound":"This licence cannot be found on the profile.",
                "tempWorkerNotFound":"This temp worker cannot be found.",
                "reasonNotFound":"This refusal reason no longer exists: choose another one.",
                "loadFailed":"The licence could not be loaded.",
                "catalogueFailed":"The list of licences could not be loaded.",
                "generic":"An error occurred, please try again."
            }
        },
        "companyPanel":{
            "detailedView":"Detailed view"
        },
        "agencyGoals":{
            "pageTitle":"Settings · Agency goals",
            "previousYear":"Previous year",
            "nextYear":"Next year",
            "loadError":"The agency goals could not be loaded.",
            "retry":"Retry",
            "globalTitle":"{year} revenue goal",
            "globalText":"The revenue to reach over the year. The territories table shares it out down to 0.",
            "left":"Left to share: {amount}",
            "shared":"Goal fully shared",
            "over":"The table exceeds the goal by {amount}",
            "noTerritory":"No territory: they come from the departments of the companies.",
            "colTerritory":"Territory",
            "colClients":"New clients",
            "colRevenue":"Target revenue",
            "total":"Total",
            "unsaved":"Unsaved changes",
            "invalid":"A number of clients is a whole number, amounts are positive numbers.",
            "cancel":"Cancel",
            "save":"Save",
            "saved":"Agency goals saved",
            "saveError":"The goals could not be saved, please try again.",
            "cardTitle":"Agency goals · {year}",
            "colSigned":"Clients signed",
            "colRevenueDone":"Revenue generated",
            "cardEmpty":"No goal for {year}: they are set in the admin console, Settings › Agency goals.",
            "ofGoal":"{done} / {goal}",
            "etpTitle":"What an FTE is worth",
            "etpText":"An FTE is a full-time temp worker: a month of SMIC billed at the average coefficient.",
            "smic":"Gross hourly SMIC €{amount}",
            "hours":"{hours} h a month",
            "coefficient":"Average billing coefficient",
            "price":"{amount} per FTE a month",
            "rampText":"A new client starts at a few FTE the month it signs, then grows each month up to the FTE of its size.",
            "rampStart":"starts at",
            "rampStartOf":"Starting FTE: {size}",
            "rampGrowth":"grows by",
            "rampGrowthOf":"Monthly growth: {size}",
            "perMonth":"% a month",
            "rampMax":"up to",
            "rampMaxOf":"Highest FTE: {size}",
            "planTitle":"Action plan",
            "planText":"The new clients to sign each month, by territory and size. The territory rows give the revenue of each month.",
            "clientsIn":"New {size} clients, {territory}, {month}",
            "cardAside":"the tick: where the plan expects the agency today"
        },
        "stats":{
            "previous":"Previous period",
            "next":"Next period",
            "kind_week":"Week",
            "kind_month":"Month",
            "kind_quarter":"Quarter",
            "kind_custom":"Period",
            "myReview":"My weekly review",
            "loadError":"The statistics could not be loaded.",
            "retry":"Retry",
            "noCommercialTitle":"No sales rep in the team",
            "noCommercialText":"The statistics follow the Sales accounts: they show as soon as there is one.",
            "versus":"vs {period}",
            "weekShort":"W{n}",
            "weekLabel":"W{n} · {range}",
            "monthLabel":"{month} {year}",
            "quarterShort":"Q{n}",
            "quarterLabel":"Q{n} {year} · {from} – {to}",
            "ofMonth":"of {month}",
            "ofMonthVowel":"of {month}",
            "hi":", {name}",
            "bannerCustomReached":"Goal reached over the period",
            "bannerCustomOngoing":"Period under way",
            "bannerCustomOver":"Period over",
            "bannerCustomTextOne":"{n} meetings booked out of {goal}, {count} day at {weekGoal} a week.",
            "bannerCustomTextOther":"{n} meetings booked out of {goal}, {count} days at {weekGoal} a week.",
            "bannerReviewDo":"Do my weekly review",
            "bannerReviewAgain":"See my review again",
            "bannerReviewSee":"See their review",
            "pillStreakOne":"1 week of reviews",
            "pillStreak":"{count} weeks in a row",
            "bannerWeekReached":"Great week{hi}!",
            "bannerWeekReachedOther":"Weekly goal reached",
            "bannerWeekReachedText":"Goal reached: {n} meetings booked out of {goal}.",
            "bannerBestWeeksOwn":" Your best week in {count} weeks.",
            "bannerBestMonthsOwn":" Your best week in {count} months.",
            "bannerBestWeeksOther":" Best week in {count} weeks.",
            "bannerBestMonthsOther":" Best week in {count} months.",
            "bannerWeekOngoing":"Keep going{hi}!",
            "bannerWeekOngoingOther":"Week under way",
            "bannerWeekOngoingText":"{n} meetings booked out of {goal} this week. {left} more to reach the goal.",
            "bannerWeekOver":"Week {period} over",
            "bannerWeekOverText":"{n} meetings booked out of {goal}.",
            "pillMonthOngoingOne":"{count} review out of {total} this month",
            "pillMonthOngoingOther":"{count} reviews out of {total} this month",
            "pillMonthOverOne":"{count} review out of {total} in {month}",
            "pillMonthOverOther":"{count} reviews out of {total} in {month}",
            "pillQuarterOne":"{count} review out of {total}",
            "pillQuarterOther":"{count} reviews out of {total}",
            "bannerMonthLink":"See the detail by week",
            "bannerMonthReached":"Monthly goal reached",
            "bannerMonthText":"{n} meetings out of {goal} in {month}.",
            "bannerMonthStart":"Good start of the month",
            "bannerMonthMiddle":"Halfway",
            "bannerMonthEnd":"Home stretch",
            "bannerMonthOngoingText":"{n} meetings out of {goal} in {month}. {left} more to reach the goal.",
            "bannerMonthOver":"{month} over",
            "bannerQuarterLink":"Compare with {period}",
            "bannerQuarterReached":"Quarterly goal reached",
            "bannerQuarterSolid":"A solid quarter",
            "bannerQuarterOngoing":"The quarter is under way",
            "bannerQuarterOver":"{period} over",
            "bannerQuarterText":"{n} meetings out of {goal}, {pct} % of the {period} goal.",
            "reminder":"It’s {day}: 2 minutes to review your week.",
            "reminderCta":"Do my review",
            "prospection":"Prospecting",
            "funnel_calls":"People called",
            "funnel_pickedUp":"Picked up",
            "funnel_discussions":"Conversations",
            "funnel_rdvTaken":"Meetings booked",
            "ratePickedUp":"Pick-up",
            "rateDiscussion":"Conversation",
            "rateRdvPerDiscussion":"Meetings / conversations",
            "rateRdvPerCall":"Meetings / calls",
            "results":"Results",
            "resultHeldOne":"Meeting held",
            "resultHeldOther":"Meetings held",
            "resultInboundOne":"Inbound request",
            "resultInboundOther":"Inbound requests",
            "resultSalesOne":"Sale signed",
            "resultSalesOther":"Sales signed",
            "resultRevenue":"Revenue generated",
            "resultRevenueEstimated":"of which {amount} estimated",
            "resultRevenueEstimatedHint":"A sale without an invoice counts for the estimate of its timesheets.",
            "resultShowUp":"Show-up",
            "resultClosing":"Closing",
            "record":"Record",
            "goalLabel":"Goal: {value}",
            "weekBar":"W{n}",
            "chartTitleDay":"{metric} by day{suffix}",
            "chartTitleWeek":"{metric} by week{suffix}",
            "metric_rdvTaken":"Meetings booked",
            "metric_calls":"People called",
            "metric_pickedUp":"Picked up",
            "metric_discussions":"Conversations",
            "metric_rdvDone":"Meetings held",
            "metric_sales":"Sales signed",
            "metricTitle_rdvTaken":"Meetings booked",
            "metricTitle_calls":"Calls",
            "metricTitle_pickedUp":"Pick-ups",
            "metricTitle_discussions":"Conversations",
            "metricTitle_rdvDone":"Meetings held",
            "metricTitle_sales":"Sales",
            "feelingMine":"How I feel",
            "feelingOf":"How {name} feels",
            "feelingTeam":"How the team feels",
            "feeling_confidence":"Confidence on calls",
            "feeling_questioning":"Questioning",
            "feeling_objections":"Objections",
            "feeling_energy":"Energy",
            "feelingAsideWeek":"review W{n}",
            "feelingAsideWeekAverage":"average {period}",
            "feelingAsideMonth":"average {month}",
            "feelingAsideQuarter":"average of {period}",
            "feelingAsideCustom":"average of the period",
            "feelingEmptyOwn":"No review yet: do the first one to follow how you feel.",
            "feelingEmptyOther":"No review yet.",
            "feelingEmptyWeek":"No review in {period}.",
            "feelingEmptyMonth":"No review in {month}.",
            "feelingEmptyQuarter":"No review in {period}.",
            "feelingEmptyCustom":"No review over the period.",
            "dots":"{value} out of 5",
            "pickerPrevious":"Previous",
            "pickerNext":"Next",
            "weekdayInitials":"M,T,W,T,F,S,S",
            "quarterTile":"Q{n} · {from} – {to}",
            "rangeFirst":"Pick the first day",
            "rangeLast":"Pick the last day",
            "rangeDaysOne":"{count} day",
            "rangeDaysOther":"{count} days",
            "rangeApply":"Apply",
            "reviewTitle":"My review · W{n}",
            "reviewOfTitle":"Review of {name} · W{n}",
            "reviewIntro":"2 minutes to take stock. Seen by you and your agency manager.",
            "savedOn":"Saved on {day} · seen by you and your agency manager",
            "savedOnBy":"Saved on {day}",
            "noReviewYet":"No review for this week yet.",
            "chipCallsOne":"{count} call",
            "chipCallsOther":"{count} calls",
            "chipRdv":"{count} meetings booked",
            "chipSalesOne":"{count} sale",
            "chipSalesOther":"{count} sales",
            "scaleLow":"1 = to work on",
            "scaleHigh":"5 = top",
            "scale_confidence":"My confidence on calls",
            "scale_questioning":"My questioning",
            "scale_questioningHint":"rather than arguing",
            "scale_objections":"My handling of objections",
            "scale_energy":"My energy, my motivation",
            "victoryLabel":"My win of the week",
            "victoryPlaceholder":"A call, a meeting, a client’s feedback…",
            "challengeLabel":"One challenge for next week",
            "challengePlaceholder":"A concrete, measurable challenge",
            "later":"Later",
            "close":"Close",
            "saveReview":"Save my review",
            "saveError":"The review could not be saved, please try again.",
            "savedTitle":"Review saved",
            "savedChallenge":"Your challenge for next week: {challenge}.",
            "savedReminder":" We’ll remind you on Monday morning.",
            "savedNoChallenge":"Your weekly review is saved.",
            "savedStreak":"{count} weeks of reviews in a row",
            "savedFirst":"First review of your streak"
        },
        "adminConsole":{
            "roleSelectLabel":"Role of {name}",
            "roleMissions":"Missions",
            "roleUpdated":"Role updated",
            "roleErrors":{
                "memberNotFound":"This member cannot be found: the list was refreshed.",
                "unknownRole":"This role does not exist.",
                "notAnAdmin":"This account is not part of the team: the list was refreshed.",
                "memberDeactivated":"This member is deactivated: reactivate them before changing their role.",
                "ownRole":"You cannot change your own role.",
                "superAdmin":"The role of an agency manager cannot be changed.",
                "generic":"The role could not be updated, please try again."
            },
            "deactivateErrors":{
                "self":"You cannot deactivate your own access.",
                "superAdmin":"The access of an agency manager cannot be deactivated.",
                "memberNotFound":"This member cannot be found.",
                "generic":"The access could not be deactivated, please try again."
            },
            "sizesPageTitle":"Settings · Client size",
            "sizesTitle":"Client size",
            "sizesText":"A prospect keeps the size chosen when it was created. A client takes its own from its timesheets, against these thresholds.",
            "sizesSize":"SIZE",
            "sizesRule":"RULE",
            "sizesFrom":"From",
            "sizesEtp":"FTE",
            "sizesInputLabel":"Threshold in FTE: {size}",
            "sizesBelow":"Under {etp} FTE",
            "sizesHow":"FTE: the hours of the timesheets of the last 3 whole months, divided by 151.67 h a month, then by 3. Until a client has a timesheet, it keeps the size chosen.",
            "sizesInvalid":"A threshold is a number of FTE above 0.",
            "sizesOrder":"The SME threshold is below the key account one.",
            "sizesSaved":"Thresholds saved",
            "sizesSaveError":"The thresholds could not be saved, please try again.",
            "sizesLoadError":"The thresholds could not be loaded.",
            "goalsPageTitle":"Settings · Sales reps goals",
            "goalsTitle":"Goals",
            "goalsText":"What each sales rep aims at: calls and meetings booked a week, meetings held, sales and revenue a month. They show in Statistics, beside the figures.",
            "goalsCommercial":"SALES REP",
            "goalsRdvWeek":"MEETINGS BOOKED / WEEK",
            "goalsInputLabel":"{goal} aimed at by {name}",
            "goalsNone":"No active sales rep.",
            "goalsLoadError":"The goals could not be loaded.",
            "goalsRetry":"Retry",
            "goalsUnsaved":"Unsaved changes",
            "goalsInvalid":"A goal is a whole number, 0 or more.",
            "goalsCancel":"Cancel",
            "goalsSave":"Save",
            "goalsSaved":"Goals saved",
            "goalsSaveError":"The goals could not be saved, please try again.",
            "goalsColumn_calls":"CALLS / WEEK",
            "goalsColumn_rdvTaken":"MEETINGS / WEEK",
            "goalsColumn_rdvDone":"HELD / MONTH",
            "goalsColumn_sales":"SALES / MONTH",
            "goalsColumn_revenue":"REVENUE / MONTH (€)",
            "goalsName_calls":"Calls a week",
            "goalsName_rdvTaken":"Meetings booked a week",
            "goalsName_rdvDone":"Meetings held a month",
            "goalsName_sales":"Sales a month",
            "goalsName_revenue":"Revenue a month"
        },
        "createMission":{
            "coefficient":{
                "title":"Billing coefficient",
                "loading":"Loading…",
                "companyValue":"{value} — company value",
                "noRange":"No usable range for this wage",
                "unavailable":"Company value unavailable",
                "overridden":"{value} — changed for this mission",
                "overriddenCompany":"Company value: {value}",
                "edit":"Edit",
                "inputLabel":"Mission coefficient",
                "emptyHint":"Left empty, the coefficient follows the company grid.",
                "invalid":"Enter a coefficient greater than 0 and lower than 10 (e.g. 1.85).",
                "reset":"Back to the company value"
            },
            "perimeter":{
                "title":"Perimeter",
                "description":"The managers of the chosen perimeter see the mission. Directors and administrators always see every mission.",
                "label":"Mission perimeter",
                "none":"No perimeter",
                "noneHint":"Visible to every manager",
                "loading":"Loading perimeters…",
                "loadError":"The company's perimeters could not be loaded: without them, the mission will be visible to every manager.",
                "retry":"Retry",
                "errors":{
                    "notFound":"The chosen perimeter no longer exists: the list was refreshed, choose another one.",
                    "archived":"The chosen perimeter has just been archived: the list was refreshed, choose another one."
                }
            }
        },
        "crmUi":{
            "markTodo":"Mark as to do",
            "markDone":"Mark as done",
            "choose":"Choose",
            "close":"Close",
            "previousMonth":"Previous month",
            "nextMonth":"Next month",
            "chooseDay":"Choose a day",
            "filters":"Filters",
            "removeFilter":"Remove the filter",
            "reset":"Reset",
            "apply":"Apply",
            "assign":"Assign",
            "meSuffix":"{name} (me)"
        },
        map : new Map()
    }
}